import React from "react";
import { WidthProvider, Responsive } from "react-grid-layout";
import BsyDialog from "../../BsyDialog";
import BsyDashboardComponent from "../BsyDashboardComponent";
import BsyDashboardCustomDashConfig from "../BsyDashboardCustomDashConfig";
import BsyDashboardCarouselMapConfig from "../BsyDashboardCarouselMapConfig";

import closeCustomImg from "../../../images/dashboard/img_zidingyi@2x.png";
import { BsyUtils } from "../../../utils/Utils";
import BsyIconBtn from "../../BsyIconBtn";
import BsySlidePane from "../../BsySlidePane";
import BsyAlert from "../../BsyAlert";
import BsyAlertMenu from "../../BsyAlertMenu";
import BsyDashboardDesignAuth from "../BsyDashboardDesignAuth";
import BsyDashboardDesignPreviewPane from "../BsyDashboardDesignPreviewPane";
import CreateDesign from "./CreateDesign";
import DocumentTitle from "react-document-title";

import { arrayMoveImmutable } from "array-move";
import "./index.css";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import _ from "lodash";
import BsySystemRightMenu from "../../BsySystemRightMenu";
import BsySystemLeftMenu from "../../BsySystemLeftMenu";
import { createTooltip } from "../../../utils/createTooltip";
import BsyMaskLayer from "../../BsyMaskLayer";
import BsySLoading from "../../BsySLoading";
import { filterDuplicateWidgets } from "../../../utils/filterDuplicateWidgets";
import { normalizeComponents } from "../../../utils/normalizeComponents";
import { setPageTitle } from "../../../utils/setPageTitle";

const ResponsiveGridLayout = WidthProvider(Responsive);

const DEFAULT_SIZE = {
  flowManagement: {
    horizontal: {
      defaultSizeX: 60,
      defaultSizeY: 10,
      minSizeX: 30,
      minSizeY: 5,
      maxSizeX: 60,
      maxSizeY: 15,
    },
    vertical: {
      defaultSizeX: 20,
      defaultSizeY: 20,
      minSizeX: 10,
      minSizeY: 15,
      maxSizeX: 25,
      maxSizeY: 30,
    },
  },
  flowManagementV2: {
    horizontal: {
      defaultSizeX: 60,
      defaultSizeY: 6,
      minSizeX: 52,
      minSizeY: 6,
      maxSizeX: 60,
      maxSizeY: 6,
    },
    "card-cross": {
      defaultSizeX: 60,
      defaultSizeY: 6,
      minSizeX: 52,
      minSizeY: 6,
      maxSizeX: 60,
      maxSizeY: 6,
    },
    "card-vertical": {
      defaultSizeX: 40,
      defaultSizeY: 8,
      minSizeX: 40,
      minSizeY: 8,
      maxSizeX: 60,
      maxSizeY: 8,
    },
    combo: {
      defaultSizeX: 12,
      defaultSizeY: 9,
      minSizeX: 12,
      minSizeY: 9,
      maxSizeX: 12,
      maxSizeY: 9,
    },
  },
  myDash: {
    defaultSizeX: 60,
    defaultSizeY: 6,
    minSizeX: 43,
    minSizeY: 6,
    maxSizeX: 60,
    maxSizeY: 6,
  },
  favorites: {
    defaultSizeX: 60,
    defaultSizeY: 6,
    minSizeX: 12,
    minSizeY: 6,
    maxSizeX: 60,
    maxSizeY: 6,
  },
  speedyEntry: {
    defaultSizeX: 60,
    defaultSizeY: 4,
    minSizeX: 10,
    minSizeY: 4,
    maxSizeX: 60,
    maxSizeY: 15,
  },
  speedyEntryV2: {
    defaultSizeX: 60,
    defaultSizeY: 6,
    minSizeX: 12,
    minSizeY: 6,
    maxSizeX: 60,
    maxSizeY: 6,
  },
  recentUse: {
    defaultSizeX: 60,
    defaultSizeY: 6,
    minSizeX: 12,
    minSizeY: 6,
    maxSizeX: 60,
    maxSizeY: 6,
  },
  noticeBoard: {
    defaultSizeX: 40,
    defaultSizeY: 6, // 7 10 8
    minSizeX: 20,
    minSizeY: 6,
    maxSizeX: 60,
    maxSizeY: 6,
  },
  customApp: {
    //报表看板
    defaultSizeX: 60,
    defaultSizeY: 8,
    minSizeX: 10,
    minSizeY: 8,
    maxSizeX: 60,
    maxSizeY: 8,
  },
  richText: {
    defaultSizeX: 60,
    defaultSizeY: 6,
    minSizeX: 12,
    minSizeY: 5,
    maxSizeX: 60,
    // maxSizeY: 60
  },
  myApp: {
    defaultSizeX: 60,
    defaultSizeY: 9,
    minSizeX: 43,
    minSizeY: 9,
    maxSizeX: 60,
    maxSizeY: 9,
  },
  dockApp: {
    defaultSizeX: 60,
    defaultSizeY: 8,
    minSizeX: 43,
    minSizeY: 8,
    maxSizeX: 60,
    maxSizeY: 8,
  },
  customDash: {
    defaultSizeX: 20,
    defaultSizeY: 10,
    minSizeX: 7,
    minSizeY: 2,
    maxSizeX: 60,
    maxSizeY: 64,
  },
  carouselMap: {
    defaultSizeX: 60,
    defaultSizeY: 6,
    minSizeX: 12,
    minSizeY: 6,
    maxSizeX: 60,
    maxSizeY: 60,
  },
  filterBtn: {
    minSizeX: 10,
    minSizeY: 6,
  },
};

const DEFAULT_MOBILE_SIZE = {
  flowManagement: {
    horizontal: {
      defaultSizeX: 60,
      defaultSizeY: 3,
      minSizeX: 30,
      minSizeY: 5,
      maxSizeX: 60,
      maxSizeY: 15,
    },
    vertical: {
      defaultSizeX: 20,
      defaultSizeY: 20,
      minSizeX: 10,
      minSizeY: 15,
      maxSizeX: 25,
      maxSizeY: 30,
    },
  },
  flowManagementV2: {
    horizontal: {
      defaultSizeX: 60,
      defaultSizeY: 3,
      minSizeX: 60,
      minSizeY: 10,
      maxSizeX: 60,
      maxSizeY: 10,
    },
  },
  speedyEntry: {
    defaultSizeX: 60,
    defaultSizeY: 3,
    minSizeX: 10,
    minSizeY: 5,
    maxSizeX: 60,
    maxSizeY: 15,
  },
  recentUse: {
    defaultSizeX: 60,
    defaultSizeY: 6,
    minSizeX: 10,
    minSizeY: 6,
    maxSizeX: 60,
    maxSizeY: 6,
  },
  noticeBoard: {
    defaultSizeX: 60,
    defaultSizeY: 3,
    minSizeX: 10,
    minSizeY: 5,
    maxSizeX: 60,
    maxSizeY: 15,
  },
  richText: {
    defaultSizeX: 8,
    defaultSizeY: 6,
    minSizeX: 60,
    minSizeY: 4,
    maxSizeX: 60,
    // maxSizeY: 15
  },
  speedyEntryV2: {
    defaultSizeX: 60,
    defaultSizeY: 3,
    minSizeX: 60,
    minSizeY: 6,
    maxSizeX: 60,
    maxSizeY: 6,
  },
  customApp: {
    defaultSizeX: 60,
    defaultSizeY: 4,
    minSizeX: 60,
    minSizeY: 8,
    maxSizeX: 60,
    maxSizeY: 8,
  },
  myDash: {
    defaultSizeX: 60,
    defaultSizeY: 4,
    minSizeX: 60,
    minSizeY: 8,
    maxSizeX: 60,
    maxSizeY: 8,
  },
  favorites: {
    defaultSizeX: 60,
    defaultSizeY: 4,
    minSizeX: 60,
    minSizeY: 8,
    maxSizeX: 60,
    maxSizeY: 8,
  },
  dockApp: {
    defaultSizeX: 60,
    defaultSizeY: 8,
    minSizeX: 60,
    minSizeY: 8,
    maxSizeX: 60,
    maxSizeY: 8,
  },
  customDash: {
    defaultSizeX: 60,
    defaultSizeY: 5,
    minSizeX: 7,
    minSizeY: 6,
    maxSizeX: 60,
    maxSizeY: 32,
  },
  filterBtn: {
    minSizeX: 10,
    minSizeY: 6,
  },
  carouselMap: {
    defaultSizeX: 60,
    defaultSizeY: 3,
    minSizeX: 2,
    minSizeY: 5,
    maxSizeX: 5,
    maxSizeY: 20,
  },
};

class BsyDashboardDesign extends React.Component {
  static defaultProps = {
    designType: "company",
    isDraggable: true,
    isResizable: true,
    rowHeight: 18, //(document.documentElement.clientWidth - 250) / 60 - 10,
    selectDesignType: "",
    selectDesignId: "",
    onLayoutChange: function () { },
    cols: 60,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectDesignType: props.match.params.type,
      selectDesignId: "",
      list: [
        {
          name: React.language("app.mine"),
          id: "myApp",
        },
        {
          name: React.language("flow.toDo"),
          id: "flowManagementV2",
        },
        {
          name: React.language("speedy.entry"),
          id: "speedyEntryV2",
        },
        // {
        //     name: React.language('app.common'),
        //     id: 'customApp'
        // },

        {
          name: React.language("chart.board"),
          id: "customDash",
        },

        {
          name: React.language("app.carousel.map"),
          id: "carouselMap",
        },
        {
          name: React.language("app.recent.use"),
          id: "recentUse",
        },
        {
          name: React.language("app.notice.board"),
          id: "noticeBoard",
        },
        {
          name: React.language("dash.mine"),
          id: "myDash",
        },
        {
          name: React.language("app.favorites"),
          id: "favorites",
        },
        {
          name: React.language("app.rich.text"),
          id: "richText",
        },
        {
          name: React.language("app.dock"),
          id: "dockApp",
        },

        // {
        //     name: React.language('filter.condition'),
        //     id: 'filterBtn'
        // }
      ],
      layoutComponents: [
        {
          name: React.language("custom.dashboard.subtitle.left.bar"),
          id: "leftComponents",
        },
        {
          name: React.language("custom.dashboard.subtitle.right.bar"),
          id: "rightComponents",
        },
        {
          name: React.language("custom.dashboard.subtitle.middle.bar"),
          id: "oddComponents",
        },
        {
          name: React.language("custom.dashboard.subtitle.tab.bar"),
          id: "tabComponents",
        },
      ],
      mobileComponentsMaps: {},
      mobileComponents: [],
      mobileHideComponents: [],
      components: props.components,
      haveNews: false,
      customApp: {},
      flowManagementType: "card-cross", // card-vertical combo
      carouselMap: {},
      recentUse: {},
      richText: {},
      noticeBoard: {},
      customDash: {},
      dockApp: {},
      myDash: {},
      favorites: [],
      myApp: {},
      mobile: [],
      dockItem: props.dockItem,
      dockCorp: props.dockCorp,
      speedyEntry: {},
      preferences: {}, //多个快捷筛选,
      isIphoneSort: false, //是否进行过移动端排序
      hasCustom: false,
      loadSuccess: false,
      designType: props.designType,
      droppingItem: undefined,
      designList: [],
      dashlist: [],
      designMode: "computer",
      nameWidth: 0,
      newIsDraggable: true,
      iphoneSortTianyong: [],
      mobileSortedObjMaps: [],
      isOneceonLayoutChangeIphone: true, //切换手机端的时候第一次
      isOneceonLayoutChangeComputer: true, //切换pc的时候第一次
      hasDockApp: null, // 三个状态，null 外部应用不做处理，true 添加外部应用,false 删除外部应用
    };
    this.listMap = {
      flowManagementV2: {
        name: React.language("flow.toDo"),
        id: "flowManagementV2",
      },
      speedyEntryV2: {
        name: React.language("speedy.entry"),
        id: "speedyEntryV2",
      },
      customApp: {
        name: React.language("app.common"),
        id: "customApp",
      },
      myApp: {
        name: React.language("app.mine"),
        id: "myApp",
      },
      dockApp: {
        name: React.language("app.dock"),
        id: "dockApp",
      },
      customDash: {
        //报表看板
        name: React.language("chart.board"),
        id: "customDash",
      },
      myDash: {
        name: React.language("dash.mine"),
        id: "myDash",
      },
      favorites: {
        name: React.language("app.favorites"),
        id: "favorites",
      },
    };

    this.listComponentsMap = {
      leftComponents: {
        x: 0,
        y: Infinity,
        w: DEFAULT_SIZE.flowManagement.horizontal.defaultSizeX,
        h: DEFAULT_SIZE.flowManagement.horizontal.defaultSizeY,
        minW: DEFAULT_SIZE.flowManagement.horizontal.minSizeX,
        minH: DEFAULT_SIZE.flowManagement.horizontal.minSizeY,
        maxH: DEFAULT_SIZE.flowManagement.horizontal.maxSizeY,
        name: React.language("custom.dashboard.subtitle.left.bar"),
        id: "leftComponents",
      },
      rightComponents: {
        x: 0,
        y: Infinity,
        w: DEFAULT_SIZE.flowManagement.horizontal.defaultSizeX,
        h: DEFAULT_SIZE.flowManagement.horizontal.defaultSizeY,
        minW: DEFAULT_SIZE.flowManagement.horizontal.minSizeX,
        minH: DEFAULT_SIZE.flowManagement.horizontal.minSizeY,
        maxH: DEFAULT_SIZE.flowManagement.horizontal.maxSizeY,
        name: React.language("custom.dashboard.subtitle.right.bar"),
        id: "rightComponents",
      },
      oddComponents: {
        x: 0,
        y: Infinity,
        w: DEFAULT_SIZE.flowManagement.horizontal.defaultSizeX,
        h: DEFAULT_SIZE.flowManagement.horizontal.defaultSizeY,
        minW: DEFAULT_SIZE.flowManagement.horizontal.minSizeX,
        minH: DEFAULT_SIZE.flowManagement.horizontal.minSizeY,
        maxH: DEFAULT_SIZE.flowManagement.horizontal.maxSizeY,
        name: React.language("custom.dashboard.subtitle.middle.bar"),
        id: "oddComponents",
      },
      tabComponents: {
        x: 0,
        y: Infinity,
        w: DEFAULT_SIZE.flowManagement.horizontal.defaultSizeX,
        h: DEFAULT_SIZE.flowManagement.horizontal.defaultSizeY,
        minW: DEFAULT_SIZE.flowManagement.horizontal.minSizeX,
        minH: DEFAULT_SIZE.flowManagement.horizontal.minSizeY,
        maxH: DEFAULT_SIZE.flowManagement.horizontal.maxSizeY,
        name: React.language("custom.dashboard.subtitle.tab.bar"),
        id: "tabComponents",
      },
    };
    this.onLayoutChange = this.onLayoutChange.bind(this);
    this.nameWidthEl = React.createRef();
    this.bsyDashboardCarouselMapConfig = React.createRef();
    const { show, hide } = createTooltip();
    this.showTooltip = show;
    this.hideTooltip = hide;
  }

  componentWillUnmount() {
    this.hideTooltip();
  }

  _findAppCache = (items, appId) => {
    if (!this.appMap) {
      this.appMap = {};
      items.map((data) => {
        data.apps.map((data1) => {
          this.appMap[data1._id] = data;
          return null;
        });
        return null;
      });
    }
    return !!this.appMap[appId];
  };

  _getCache = (items) => {
    let key = "_applist_" + window.FX.STATIC.user._id + window.FX.STATIC.corpId;
    let apps = BsyUtils.Store.get(key) || [];
    if (BsyUtils.isObjectEmpty(apps)) {
      key = "_applist_" + window.FX.STATIC.corpId;
      apps = BsyUtils.Store.get(key) || [];
    }
    let appsCache = [];
    this._findAppCache(items);
    apps.map((data) => {
      if (this._findAppCache(items, data._id)) {
        appsCache.push(data);
      }
      return null;
    });
    return appsCache;
  };

  applist = (cd) => {
    const { components } = this.state;
    React.axios("/dashboard/app_group/list", {})
      .then((res) => {
        this.appMap = null;
        let apps = this._getCache(
          res.data.dock_items
            ? [...res.data.items, ...res.data.dock_items]
            : [...res.data.items]
        );
        let newComponents = [...components];
        const hasDockApp =
          (res.data?.dock_items || []).length > 0 ? true : false;
        const dockApp = components.find((item) => {
          return item.id === "dockApp";
        });
        if (hasDockApp) {
          if (!dockApp) {
            //没找到，在最后追加，
            const lastComponent = components[components.length - 1];
            const dockApp = {
              id: "dockApp",
              name: React.language("app.dock"),
              x: 0,
              y: lastComponent.y + lastComponent.h,
              w: DEFAULT_SIZE.dockApp.defaultSizeX,
              h: DEFAULT_SIZE.dockApp.defaultSizeY,
              minW: DEFAULT_SIZE.dockApp.minSizeX,
              minH: DEFAULT_SIZE.dockApp.minSizeY,
              maxH: DEFAULT_SIZE.dockApp.maxSizeY,
              maxW: DEFAULT_SIZE.dockApp.maxSizeX,
              widget: this.generateWidget(),
            };
            newComponents = [...components, dockApp];
          }
        } else {
          if (dockApp) {
            //找到，删除
            newComponents = components.filter((item) => item.id !== "dockApp");
          }
        }

        let newList = [];
        if (res.data.dock_items.length === 0) {
          newList = this.state.list.filter((item) => {
            return item.id !== "dockApp";
          });
        } else {
          newList = this.state.list;
        }
        if (BsyUtils.isObjectEmpty(this.appMap)) {
          this.setState({
            appEmpty: true,
            success: !0,
            components: [...newComponents],
            list: newList,
          });
        } else {
          this.setState({
            appsCache: apps,
            dockItem: res.data.dock_items ? [...res.data.dock_items] : [],
            dockCorp: res.data.dock_corps ? [...res.data.dock_corps] : [],
            apps: [...res.data.items],
            components: [...newComponents],
            list: newList,
          });
        }
        cd && cd();
      })
      .catch((res) => {
        console.error(res);
      });
  };

  oldComponents = [];

  getCustomConfig = () => {
    // /corp/custom_config
    const { selectDesignType } = this.state;
    let url = "/corp/custom_config_default";
    if (selectDesignType === "company") {
      url = "/corp/custom_config";
    }

    let layerRef = null;
    BsyMaskLayer({
      customCls: "hasBackground",
      onContentCreate: (ref) => {
        layerRef = ref;
        return (
          <div>
            <BsySLoading />
          </div>
        );
      },
    });
    React.axios(url, {
      edit: true,
    })
      .then((res) => {

        let hasCustom = res.data.hasCustom;
        if (!res.data.hasOwnProperty("hasCustom")) {
          hasCustom = true;
        }

        const newPc = filterDuplicateWidgets(res.data.layout.pc);

        let dash = [];
        if (!Array.isArray(res.data.customDash.dash)) {
          BsyUtils.forEach(res.data.customDash.dash, (index, data) => {
            dash.push(data);
          });
          res.data.customDash.dash = dash;
        }

        const { components, customDash } = BsyUtils.getSurplusDash(
          newPc,
          res.data.customDash.dash,
          res.data.customDash.dashExist
        );
        const n = this.deepCopy(components);
        normalizeComponents(n, res.data);
        //流程待办根据排版重新给值
        n.forEach((item) => {
          if (item.id === "flowManagementV2") {
            if (res.data.flowManagementType === "combo") {
              item.minW = 12;
              item.w = 12;
              item.h = 8;
              item.maxH = 8;
              item.minH = 8;
            }
            if (res.data.flowManagementType === "card-vertical") {
              item.minW = 40;
              item.w = 40;
              item.h = 8;
              item.maxH = 8;
              item.minH = 8;
            }
            if (res.data.flowManagementType === "card-cross" || !res.data.flowManagementType) {
              item.minW = 52;
              item.w = 60;
              item.h = 6;
              item.maxH = 6;
              item.minH = 6;
            }
          }
          //将老数据gridconmengt最小高度，宽度值初始化为前端初始化值------start
          if (item.id === "speedyEntryV2") {
            item.minW = DEFAULT_SIZE.speedyEntryV2.minSizeX;
          }
          if (item.id === "dockApp") {
            item.minH = DEFAULT_SIZE.dockApp.minSizeY;
            item.maxH = DEFAULT_SIZE.dockApp.maxSizeY;
            item.h = DEFAULT_SIZE.dockApp.defaultSizeY;
            item.minW = DEFAULT_SIZE.dockApp.minSizeX;
          }
          if (item.id === "myApp") {
            item.minH = DEFAULT_SIZE.myApp.minSizeY;
            item.maxH = DEFAULT_SIZE.myApp.maxSizeY;
            item.h = DEFAULT_SIZE.myApp.defaultSizeY;
          }
          if (item.id === "flowManagement") {
            item.id = "flowManagementV2"
            item.minH = 8
            item.h = 8
            item.maxH = 8
            item.minW = 40
            item.w = 40
          }
          //将老数据gridconmengt最小高度，宽度值初始化为前端初始化值------end
        });
        let fm = {};
        const nm = [];
        const mobile = [];
        BsyUtils.forEach(this.deepCopy(newPc), (key, val) => {
          mobile.push({
            id: val.id,
            widget: val.widget,
            widgetId: val.widgetId,
            enable: val.hasOwnProperty("enable") ? val.enable : true,
          });
          if (val.id === "flowManagementV2") {
            fm = val;
          } else {
            nm.push(val);
          }
        });
        if (fm.id === "flowManagementV2") {
          nm.unshift(fm);
        }

        let mobileHideComponents = [];
        if (res.data.layout.mobile) {
          res.data.layout.mobile.map((res) => {
            if (!res.enable) {
              mobileHideComponents.push(res.widget);
            }
            return null;
          });
        }

        const { mobileComponents } = BsyUtils.getSurplusMobileDash(
          nm,
          res.data.customDash.dash,
          res.data.customDash.dashExist
        );
        const m = this.deepCopy(mobileComponents);
        const mobileComponentsMaps = {};
        m.map((res) => {
          mobileComponentsMaps[res.widget] = res;
          return null;
        });

        this.oldComponents = this.deepCopy(n);

        // mobileSortedObjMaps 根据位置重新排序-----start
        let mobileSortedObjMaps = [];
        if (res.data.isIphoneSort) {
          mobileSortedObjMaps =
            res.data.layout.mobileLayout || mobileSortedObjMaps;
        } else {
          let mobileList = this.deepCopy(res.data.layout.mobile);
          mobileList.forEach((item, key) => {
            if (mobileComponentsMaps.hasOwnProperty(item.widget)) {
              mobileSortedObjMaps.push(mobileComponentsMaps[[item.widget]]);
            }
          });
        }
        // mobileSortedObjMaps 根据位置重新排序-----end

        if (res.data.dashlist) {
          let dashDesignMap = {};
          let fId = "";
          res.data.dashlist.map((res1, key) => {
            dashDesignMap[res1.id] = res1;
            if (key === 0) {
              fId = res1.id;
            }
            return null;
          });

          this.setState(
            {
              components: n,
              mobile: res.data.layout.mobile ? res.data.layout.mobile : mobile,
              iphoneSortTianyong: this.deepCopy(
                res.data.layout.mobile ? res.data.layout.mobile : mobile
              ),
              mobileHideComponents: mobileHideComponents,
              mobileComponents: m,
              mobileComponentsMaps: { ...mobileComponentsMaps },
              mobileCustomDash: {
                dash: customDash,
                enable: true,
              },
              customDash: {
                dash: customDash,
                enable: true,
              },
              selectDesignId: res.data.id,
              dashlist: res.data.dashlist,
              dashDesignMap: dashDesignMap,
              loadSuccess: true,
              hasCustom: hasCustom,
              isIphoneSort: res.data.isIphoneSort,
              mobileSortedObjMaps: mobileSortedObjMaps,
              speedyEntry: { ...res.data.speedyEntry },
              customApp: { ...res.data.customApp },
              carouselMap: { ...res.data.carouselMap },
              recentUse: { ...res.data.recentUse },
              richText: { ...res.data.richText },
              noticeBoard: { ...res.data.noticeBoard },
              flowManagementType: res.data.flowManagementType,
              dockApp: { ...res.data.dockApp },
              preferences: { ...res.data.preferences },
              myDash: res.data.myDash ? res.data.myDash : customDash,
              favorites: res.data.favorites ? res.data.favorites : [],
            },
            () => {
              this.checkListStatus();
              this.nameWidthEl.current &&
                this.setState({
                  nameWidth: this.nameWidthEl.current.offsetWidth + 5,
                });
            }
          );
        } else {
          this.setState(
            {
              components: n,
              mobileHideComponents: mobileHideComponents,
              mobile: res.data.layout.mobile ? res.data.layout.mobile : mobile,
              iphoneSortTianyong: this.deepCopy(
                res.data.layout.mobile ? res.data.layout.mobile : mobile
              ),
              mobileComponents: m,
              mobileComponentsMaps: { ...mobileComponentsMaps },
              customDash: {
                dash: customDash,
                enable: true,
              },
              selectDesignId: res.data.id,
              loadSuccess: true,
              hasCustom: hasCustom,
              carouselMap: { ...res.data.carouselMap },
              isIphoneSort: res.data.isIphoneSort,
              mobileSortedObjMaps: mobileSortedObjMaps,
              recentUse: { ...res.data.recentUse },
              richText: { ...res.data.richText },
              noticeBoard: { ...res.data.noticeBoard },
              flowManagementType: res.data.flowManagementType,
              speedyEntry: { ...res.data.speedyEntry },
              customApp: { ...res.data.customApp },
              dockApp: { ...res.data.dockApp },
              preferences: { ...res.data.preferences },
              myDash: res.data.myDash ? res.data.myDash : customDash,
              favorites: res.data.favorites ? res.data.favorites : [],
            },
            () => {
              this.checkListStatus();
              this.nameWidthEl.current &&
                this.setState({
                  nameWidth: this.nameWidthEl.current.offsetWidth + 5,
                });
            }
          );
        }

        this.applist(() => {
          layerRef && layerRef.close();
        });
      })
      .catch(() => {
        layerRef && layerRef.close();
      });
  };

  componentDidMount() {
    if (this.props.getContext) {
      this.props.getContext(this);
    }
    this.getCustomConfig();
    this._getMsgUnread();
    //this._getDesignList();
    this.nameWidthEl.current &&
      this.setState({ nameWidth: this.nameWidthEl.current.offsetWidth + 5 });
  }

  _getDesignList = () => {
    React.axios("/dashboard/config_dash/list").then((res) => {
      this.setState({ designList: res.data.list });
    });
  };
  setSpeedyEntryGrid = (comments, speedyEntry, recentUse) => {
    //最近使用
    let recentUseListwNum =
      Math.floor((window.$(".react-grid-recentUse").width() - 40) / 190) || 1;
    let recentUseListhNum = Math.ceil(
      recentUse && recentUse.list && recentUse.list.length / recentUseListwNum
    );
    // let recentUseListAllHeight = 54 * recentUseListhNum + 14 + 20 + 40;
    // let recentUseGridListH = (recentUseListAllHeight + 16) / (18 + 16);
    // if(!recentUse.list || recentUse.list.length === 0){
    //   recentUseGridListH = 6
    // }
    let j1 = JSON.parse(JSON.stringify(comments));
    j1.forEach((item) => {
      if (item.id.includes("speedyEntryV2")) {
        //list类型
        let speedyEntryListwNum =
          Math.floor((window.$("." + item.id).width() - 40) / 190) || 1; //一排几个
        let speedyEntryListhNum = Math.ceil(
          speedyEntry[item.id].entries.length / speedyEntryListwNum
        ); // 有几排
        let speedyEntryListAllHeight = 54 * speedyEntryListhNum + 14 + 20 + 40; //一共多高 计算公式 h * row + (h - 1) * padding = 426 注释：h为设置的defaultSizeY，row行高目前设置18，padding设置16
        let gridListH = (speedyEntryListAllHeight + 16) / (18 + 16);
        // card类型
        let speedyEntryCardwNum =
          Math.floor((window.$("." + item.id).width() - 40) / 190) || 1; //一排几个
        let speedyEntryCardhNum = Math.ceil(
          speedyEntry[item.id].entries.length / speedyEntryCardwNum
        ); // 有几排
        let speedyEntryCardAllHeight = 120 * speedyEntryCardhNum + 14 + 20 + 40; //一共多高 计算公式 h * row + (h - 1) * padding = 426 注释：h为设置的defaultSizeY，row行高目前设置18，padding设置16
        let gridCardH = (speedyEntryCardAllHeight + 16) / (18 + 16);

        if (speedyEntry[item.id].entries.length === 0) {
          gridListH = 6;
          gridCardH = 6;
        }
        if (
          speedyEntry[item.id].entries.length > 0 &&
          (speedyEntry[item.id].layoutStyle === "list" ||
            !speedyEntry[item.id].layoutStyle)
        ) {
          item.h = Math.ceil(gridListH);
          item.maxH = Math.ceil(gridListH);
          item.minH = Math.ceil(gridListH);
        }
        if (
          speedyEntry[item.id].entries.length > 0 &&
          speedyEntry[item.id].layoutStyle === "card"
        ) {
          item.h = Math.ceil(gridCardH);
          item.maxH = Math.ceil(gridCardH);
          item.minH = Math.ceil(gridCardH);
        }
        // 2025 0307 设计界面清空，会影响初始高度
        // item.h = item.h < 6 ? 6 : item.h;
      }
      // if (
      //   item.id === "recentUse" &&
      //   recentUse.list &&
      //   recentUse.list.length >= 0
      // ) {
      //   item.h = Math.ceil(recentUseGridListH);
      //   item.maxH = Math.ceil(recentUseGridListH);
      //   item.minH = Math.ceil(recentUseGridListH);

      //   item.maxH = item.h;
      //   item.minH = item.h;
      // }
    });
    return j1;
  };
  deepCopy = (obj, visited = new WeakMap()) => {
    // 如果 obj 是 null 或不是对象，直接返回它自身
    if (obj === null || typeof obj !== "object") {
      return obj;
    }

    // 如果 obj 已经被访问过，返回它的副本以避免循环引用
    if (visited.has(obj)) {
      return visited.get(obj);
    }

    // 根据 obj 的类型创建一个新的空对象或数组
    let copy;
    if (Array.isArray(obj)) {
      copy = [];
    } else {
      copy = Object.create(Object.getPrototypeOf(obj));
    }

    // 记录访问过的 obj，以便处理循环引用
    visited.set(obj, copy);

    // 遍历 obj 的属性或数组元素并进行递归深拷贝
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        copy[key] = this.deepCopy(obj[key], visited);
      }
    }

    return copy;
  };
  onLayoutChangeIphone = (layout, layouts, dd) => {
    const {
      components,
      designMode,
      mobile,
      mobileComponents,
      mobileComponentsMaps,
      isOneceonLayoutChangeIphone,
      mobileSortedObjMaps,
    } = this.state;
    if (!isOneceonLayoutChangeIphone) {
      let newMobileComponents = mobileComponents.filter((item) => {
        return ["dockApp", "invalidBlock", "myApp"].indexOf(item.id) < 0;
      });
      // 将mobileComponents 根据位置重新排序-----start
      const idToIndex = new Map();
      layout.forEach((item, index) => {
        idToIndex.set(item.i, index);
      });
      newMobileComponents.sort(
        (a, b) => idToIndex.get(a.widget) - idToIndex.get(b.widget)
      );
      mobileSortedObjMaps.sort(
        (a, b) => idToIndex.get(a.widget) - idToIndex.get(b.widget)
      );
      layout.forEach((item, key) => {
        //将mobileComponentsMaps与插件给出的y值对应
        if (mobileComponentsMaps[item.i])
          mobileComponentsMaps[item.i].y = item.y;
      });

      const newC = [];
      let newLayout = layout.sort((s, j) => {
        return s.y - j.y;
      });
      newLayout.forEach((item) => {
        //给与新的循序  newC
        let newObj = newMobileComponents.filter((itemc) => {
          return itemc.widget === item.i;
        });
        if (newObj.length > 0) {
          newC.push({
            enable: true,
            id: newObj[0].id,
            widget: newObj[0].widget,
            widgetId: newObj[0].widgetId || newObj[0].widget,
          });
        }
      });

      newMobileComponents.forEach((item) => {
        let falseC = newLayout.filter((itemC) => {
          //查出隐藏的项
          return item.widget === itemC.i;
        });
        if (falseC.length === 0) {
          newC.push({
            enable: false,
            id: item.id,
            widget: item.widget,
            widgetId: item.widgetId || item.widget,
          });
        }
      });
      this.setState({
        iphoneSortTianyong: newC,
        mobileComponents: newMobileComponents,
        mobileComponentsMaps: mobileComponentsMaps,
        mobileSortedObjMaps: mobileSortedObjMaps,
      });
    }
    this.setState({
      isOneceonLayoutChangeIphone: false,
    });
  };
  onLayoutChange = (layout, layouts) => {

    const {
      components,
      designMode,
      mobile,
      mobileComponents,
      preferences,
      recentUse,
      isIphoneSort,
      mobileSortedObjMaps,
      iphoneSortTianyong,
      isOneceonLayoutChangeComputer,
    } = this.state;
    this.props.onLayoutChange(layout, layouts);
    if (!isOneceonLayoutChangeComputer) {
      const newC = [];
      const nMobileComponentsMaps = {};
      for (let i = 0; i < components.length; i++) {
        // if (layout[i]) {
        //   components[i].y = layout[i].y;
        //   components[i].x = layout[i].x;
        //   components[i].w = layout[i].w;
        //   components[i].h = layout[i].h;
        // }
        mobileComponents[i] &&
          (nMobileComponentsMaps[mobileComponents[i].widget] =
            mobileComponents[i]);
        newC.push(components[i]);
      }
      // 将componen x,h,w,y与插件layout 赋值一致--------start
      components.forEach((item1, key) => {
        const matchedItem = layout.find(item2 => item2.i === item1.widget);
        if (matchedItem) {
          // 遍历 matchedItem 的键
          for (let key in matchedItem) {
            // 如果 item1 也有相同的键，则赋值
            if (item1.hasOwnProperty(key)) {
              item1[key] = matchedItem[key];
            }
          }
        }
      })
      // 将componen x,h,w,y与插件layout 赋值一致--------end
      let j1 = JSON.parse(JSON.stringify(components)).sort((s, j) => {
        if (s.y === j.y) {
          return s.x - j.x;
        } else {
          return s.y - j.y;
        }
      });
      if (navigator.userAgent.indexOf("Firefox") > -1) {
        j1 = j1.reverse();
      }
      if (!isIphoneSort) {
        //进行过重新排序，无需再次赋值nMobileComponentsMaps
        let newLayout = JSON.parse(JSON.stringify(layout)).sort((s, j) => {
          if (s.y === j.y) {
            return s.x - j.x;
          } else {
            return s.y - j.y;
          }
        });

        // 将mobileComponents 根据位置重新排序-----start
        const idToIndex = new Map();
        newLayout.forEach((item, index) => {
          idToIndex.set(item.i, index);
          mobileSortedObjMaps.forEach((itemC) => {
            if (item.i === itemC.widget) {
              itemC.y = item.y;
              itemC.x = item.x;
            }
          });
          // mobileSortedObjMaps[index].y = item.y
        });
        mobileSortedObjMaps.sort(
          (a, b) => idToIndex.get(a.widget) - idToIndex.get(b.widget)
        );
        iphoneSortTianyong.sort(
          (a, b) => idToIndex.get(a.widget) - idToIndex.get(b.widget)
        );
        // 将mobileComponents 根据位置重新排序-----end


        this.setState({
          components: this.setSpeedyEntryGrid(j1, preferences, recentUse),
          mobileSortedObjMaps: mobileSortedObjMaps,
          iphoneSortTianyong: iphoneSortTianyong,
        });
      } else {
        this.setState({
          components: this.setSpeedyEntryGrid(j1, preferences, recentUse),
          // components: j1,
          mobileComponentsMaps: nMobileComponentsMaps,
        });
      }
    }
    this.setState({
      isOneceonLayoutChangeComputer: false,
    });
  };

  currentDragElData = "";

  handleDragStart = (e, data) => {
    // let preferences = this.state.preferences;
    let odData = data;
    if (data.id.includes("speedyEntryV2")) {
      odData.id = "speedyEntryV2" + this.generateWidget();
    }
    this.currentDragElData = odData;
  };
  handleDrop = (l, i, e) => {
    e = e || window.event;
    e.preventDefault();

    if (this.currentDragElData && i) {
      this.addWidget(this.currentDragElData, l, i, e);
    }
    this.currentDragElData = null;
  };

  handleDragEnter = (e) => {
    // e.preventDefault();
    e = e || window.event;
    e.preventDefault();
  };
  generateWidget = () => {
    return "_widget_" + new Date().getTime();
  };

  CustomDashValue = (customDash, val) => {
    this.customDash = customDash;
    this.block = val;
  };

  addWidget = (data, l, i) => {
    const {
      components,
      customDash,
      mobile,
      mobileComponentsMaps,
      preferences,
      isIphoneSort,
      mobileSortedObjMaps,
    } = this.state;
    let mobileSortedObjMapsSrot = mobileSortedObjMaps.sort((s, j) => {
      return s.y - j.y;
    });
    const widgetId = this.generateWidget();
    let index = null;
    let xyMAP = {};
    let j = l.sort((s, j) => {
      return s.y - j.y;
    });
    j.map((res, key) => {
      if (res.i === "__dropping-elem__") {
        xyMAP[widgetId] = {
          x: res.x,
          y: res.y,
        };
        index = key;
      } else {
        xyMAP[res.i || res.widget] = {
          x: res.x,
          y: res.y,
        };
      }
      return null;
    });

    switch (data.id) {
      case "flowManagement": {
        const newcomponents = [...components];
        const newItem = {
          x: 0,
          y: i.y,
          w: DEFAULT_SIZE.flowManagement.horizontal.defaultSizeX,
          h: DEFAULT_SIZE.flowManagement.horizontal.defaultSizeY,
          minW: DEFAULT_SIZE.flowManagement.horizontal.minSizeX,
          minH: DEFAULT_SIZE.flowManagement.horizontal.minSizeY,
          maxH: DEFAULT_SIZE.flowManagement.horizontal.maxSizeY,
          ...data,
          widget: widgetId,
          layout: "horizontal",
        };
        newcomponents.splice(index, 0, newItem);
        mobileComponentsMaps[widgetId] = newItem;
        mobile.splice(index, 0, {
          widget: newItem.widget,
          id: data.id,
          enable: true,
        });
        newcomponents.map((res) => {
          res.x = xyMAP[res.i || res.widget].x;
          res.y = xyMAP[res.i || res.widget].y;
        });
        const { mobileComponents } = BsyUtils.getSurplusMobileDash(
          this.deepCopy(newcomponents),
          customDash.dash
        );
        this.setState(
          {
            components: [...newcomponents],
            mobileComponents: [...mobileComponents],
            mobileComponentsMaps: mobileComponentsMaps,
            mobile: mobile,
          },
          () => {
            this.checkListStatus();
          }
        );
        break;
      }
      case "leftComponents":
      case "rightComponents":
      case "oddComponents":
      case "tabComponents": {
        const newcomponents = [...components];
        const newItem = {
          x: xyMAP[widgetId].x,
          y: xyMAP[widgetId].y,
          w: DEFAULT_SIZE.flowManagement.horizontal.defaultSizeX,
          h: DEFAULT_SIZE.flowManagement.horizontal.defaultSizeY,
          minW: DEFAULT_SIZE.flowManagement.horizontal.minSizeX,
          minH: DEFAULT_SIZE.flowManagement.horizontal.minSizeY,
          maxH: DEFAULT_SIZE.flowManagement.horizontal.maxSizeY,
          ...data,
          autoSize: true,
          widget: widgetId,
          layout: "horizontal",
        };
        newcomponents.splice(index, 0, newItem);
        mobileComponentsMaps[widgetId] = newItem;
        mobile.splice(index, 0, {
          widget: newItem.widget,
          id: data.id,
          enable: true,
        });
        newcomponents.map((res) => {
          res.x = xyMAP[res.i || res.widget].x;
          res.y = xyMAP[res.i || res.widget].y;
        });
        const { mobileComponents } = BsyUtils.getSurplusMobileDash(
          this.deepCopy(newcomponents),
          customDash.dash
        );
        this.setState(
          {
            components: [...newcomponents],
            mobileComponents: [...mobileComponents],
            mobileComponentsMaps: mobileComponentsMaps,
            mobile: mobile,
          },
          () => {
            this.checkListStatus();
          }
        );
        break;
      }
      case "flowManagementV2": {
        const newcomponents = [...components];
        const newItem = {
          x: 0,
          y: i.y,
          w: DEFAULT_SIZE.flowManagementV2.horizontal.defaultSizeX,
          h: DEFAULT_SIZE.flowManagementV2.horizontal.defaultSizeY,
          minW: DEFAULT_SIZE.flowManagementV2.horizontal.minSizeX,
          minH: DEFAULT_SIZE.flowManagementV2.horizontal.minSizeY,
          maxH: DEFAULT_SIZE.flowManagementV2.horizontal.maxSizeY,
          ...data,
          widget: widgetId,
          layout: "horizontal",
        };
        newcomponents.splice(index, 0, newItem);
        mobileComponentsMaps[widgetId] = newItem;
        mobile.splice(index, 0, {
          widget: newItem.widget,
          id: data.id,
          enable: true,
        });
        newcomponents.map((res) => {
          res.x = xyMAP[res.i || res.widget].x;
          res.y = xyMAP[res.i || res.widget].y;
        });
        const { mobileComponents } = BsyUtils.getSurplusMobileDash(
          this.deepCopy(newcomponents),
          customDash.dash
        );
        this.setState(
          {
            components: [...newcomponents],
            mobileComponents: [...mobileComponents],
            mobileComponentsMaps: mobileComponentsMaps,
            mobile: mobile,
          },
          () => {
            this.checkListStatus();
          }
        );
        break;
      }
      case "favorites":
      case "myDash": {
        const newcomponents = [...components];
        const newItem = {
          x: 0,
          y: i.y,
          w: DEFAULT_SIZE.myDash.defaultSizeX,
          h: DEFAULT_SIZE.myDash.defaultSizeY,
          minW: DEFAULT_SIZE.myDash.minSizeX,
          minH: DEFAULT_SIZE.myDash.minSizeY,
          maxH: DEFAULT_SIZE.myDash.maxSizeY,
          ...data,
          widget: widgetId,
        };
        if (isIphoneSort) {
          const entries = Object.entries(mobileSortedObjMapsSrot);
          const lastEntry = entries[entries.length - 1];
          newItem.y = lastEntry[1].h + lastEntry[1].y;
          mobileSortedObjMapsSrot.push(newItem);
        } else {
          mobileSortedObjMapsSrot.splice(index, 0, newItem);
        }
        newcomponents.splice(index, 0, newItem);
        mobileComponentsMaps[widgetId] = newItem;
        mobile.splice(index, 0, {
          widget: newItem.widget,
          id: data.id,
          enable: true,
        });
        newcomponents.map((res) => {
          res.x = xyMAP[res.i || res.widget].x;
          res.y = xyMAP[res.i || res.widget].y;
        });
        const { mobileComponents } = BsyUtils.getSurplusMobileDash(
          this.deepCopy(newcomponents),
          customDash.dash
        );

        this.setState(
          {
            components: [...newcomponents],
            mobileComponents: [...mobileComponents],
            mobileComponentsMaps: mobileComponentsMaps,
            mobileSortedObjMaps: mobileSortedObjMapsSrot,
            mobile: mobile,
            iphoneSortTianyong: this.addIphoneWeight(
              data.id,
              mobileComponentsMaps
            ),
          },
          () => {
            this.checkListStatus();
          }
        );
        break;
      }
      case "speedyEntry": {
        const newcomponents = [...components];
        const newItem = {
          x: 0,
          y: i.y,
          w: DEFAULT_SIZE.speedyEntryV2.defaultSizeX,
          h: DEFAULT_SIZE.speedyEntryV2.defaultSizeY,
          minW: DEFAULT_SIZE.speedyEntryV2.minSizeX,
          minH: DEFAULT_SIZE.speedyEntryV2.minSizeY,
          maxH: DEFAULT_SIZE.speedyEntryV2.maxSizeY,
          ...data,
          widget: widgetId,
        };
        newcomponents.splice(index, 0, newItem);
        if (isIphoneSort) {
          const entries = Object.entries(mobileSortedObjMapsSrot);
          const lastEntry = entries[entries.length - 1];
          newItem.y = lastEntry[1].h + lastEntry[1].y;
          mobileSortedObjMapsSrot.push(newItem);
        } else {
          mobileSortedObjMapsSrot.splice(index, 0, newItem);
        }

        mobileComponentsMaps[widgetId] = newItem;
        mobile.splice(index, 0, {
          widget: newItem.widget,
          id: data.id,
          enable: true,
        });
        newcomponents.map((res) => {
          res.x = xyMAP[res.i || res.widget].x;
          res.y = xyMAP[res.i || res.widget].y;
        });

        const { mobileComponents } = BsyUtils.getSurplusMobileDash(
          this.deepCopy(newcomponents),
          customDash.dash
        );
        this.setState(
          {
            components: [...newcomponents],
            mobileComponents: [...mobileComponents],
            mobileComponentsMaps: mobileComponentsMaps,
            mobileSortedObjMaps: mobileSortedObjMapsSrot,
            mobile: mobile,
          },
          () => {
            this.checkListStatus();
          }
        );
        break;
      }
      case "customApp": {
        const newcomponents = [...components];
        const newItem = {
          x: 0,
          y: i.y,
          w: DEFAULT_SIZE.customApp.defaultSizeX,
          h: DEFAULT_SIZE.customApp.defaultSizeY,
          minW: DEFAULT_SIZE.customApp.minSizeX,
          minH: DEFAULT_SIZE.customApp.minSizeY,
          maxH: DEFAULT_SIZE.customApp.maxSizeY,
          ...data,
          widget: widgetId,
        };
        newcomponents.splice(index, 0, newItem);
        if (isIphoneSort) {
          const entries = Object.entries(mobileSortedObjMapsSrot);
          const lastEntry = entries[entries.length - 1];
          newItem.y = lastEntry[1].h + lastEntry[1].y;
          mobileSortedObjMapsSrot.push(newItem);
        } else {
          mobileSortedObjMapsSrot.splice(index, 0, newItem);
        }
        mobileComponentsMaps[widgetId] = newItem;
        mobile.splice(index, 0, {
          widget: newItem.widget,
          id: data.id,
          enable: true,
        });
        newcomponents.map((res) => {
          res.x = xyMAP[res.i || res.widget].x;
          res.y = xyMAP[res.i || res.widget].y;
        });
        const { mobileComponents } = BsyUtils.getSurplusMobileDash(
          this.deepCopy(newcomponents),
          customDash.dash
        );
        this.setState(
          {
            components: [...newcomponents],
            mobileComponents: [...mobileComponents],
            mobileComponentsMaps: mobileComponentsMaps,
            mobileSortedObjMaps: mobileSortedObjMapsSrot,
            mobile: mobile,
          },
          () => {
            this.checkListStatus();
          }
        );
        break;
      }
      case "myApp": {
        const newcomponents = [...components];
        const newItem = {
          x: 0,
          y: i.y,
          w: DEFAULT_SIZE.myApp.defaultSizeX,
          h: DEFAULT_SIZE.myApp.defaultSizeY,
          minW: DEFAULT_SIZE.myApp.minSizeX,
          minH: DEFAULT_SIZE.myApp.minSizeY,
          maxH: DEFAULT_SIZE.myApp.maxSizeY,
          ...data,
          widget: widgetId,
        };
        newcomponents.splice(index, 0, newItem);
        if (isIphoneSort) {
          const entries = Object.entries(mobileSortedObjMapsSrot);
          const lastEntry = entries[entries.length - 1];
          newItem.y = lastEntry[1].h + lastEntry[1].y;
          mobileSortedObjMapsSrot.push(newItem);
        } else {
          mobileSortedObjMapsSrot.splice(index, 0, newItem);
        }
        mobileComponentsMaps[widgetId] = newItem;
        mobile.splice(index, 0, {
          widget: newItem.widget,
          id: data.id,
          enable: true,
        });
        newcomponents.map((res) => {
          res.x = xyMAP[res.i || res.widget].x;
          res.y = xyMAP[res.i || res.widget].y;
        });
        const { mobileComponents } = BsyUtils.getSurplusMobileDash(
          this.deepCopy(newcomponents),
          customDash.dash
        );
        this.setState(
          {
            components: [...newcomponents],
            mobileComponents: [...mobileComponents],
            mobileComponentsMaps: mobileComponentsMaps,
            mobileSortedObjMaps: mobileSortedObjMapsSrot,
            mobile: mobile,
          },
          () => {
            this.checkListStatus();
          }
        );
        break;
      }
      case "recentUse": {
        const newcomponents = [...components];
        const newItem = {
          x: 0,
          y: i.y,
          w: DEFAULT_SIZE.recentUse.defaultSizeX,
          h: DEFAULT_SIZE.recentUse.defaultSizeY,
          minW: DEFAULT_SIZE.recentUse.minSizeX,
          minH: DEFAULT_SIZE.recentUse.minSizeY,
          maxH: DEFAULT_SIZE.recentUse.maxSizeY,
          ...data,
          widget: widgetId,
        };
        newcomponents.splice(index, 0, newItem);
        if (isIphoneSort) {
          const entries = Object.entries(mobileSortedObjMapsSrot);
          const lastEntry = entries[entries.length - 1];
          newItem.y = lastEntry[1].h + lastEntry[1].y;
          mobileSortedObjMapsSrot.push(newItem);
        } else {
          mobileSortedObjMapsSrot.splice(index, 0, newItem);
        }
        mobileComponentsMaps[widgetId] = newItem;
        mobile.splice(index, 0, {
          widget: newItem.widget,
          id: data.id,
          enable: true,
        });
        newcomponents.map((res) => {
          res.x = xyMAP[res.i || res.widget].x;
          res.y = xyMAP[res.i || res.widget].y;
        });
        const { mobileComponents } = BsyUtils.getSurplusMobileDash(
          this.deepCopy(newcomponents),
          customDash.dash
        );

        this.setState(
          {
            components: [...newcomponents],
            mobileComponents: [...mobileComponents],
            mobileComponentsMaps: mobileComponentsMaps,
            mobileSortedObjMaps: mobileSortedObjMapsSrot,
            mobile: mobile,
            iphoneSortTianyong: this.addIphoneWeight(
              data.id,
              mobileComponentsMaps
            ),
          },
          () => {
            this.checkListStatus();
          }
        );
        break;
      }
      case "noticeBoard": {
        const newcomponents = [...components];
        let newItem = {
          x: 0,
          y: i.y,
          w: DEFAULT_SIZE.noticeBoard.defaultSizeX,
          h: DEFAULT_SIZE.noticeBoard.defaultSizeY,
          minW: DEFAULT_SIZE.noticeBoard.minSizeX,
          minH: DEFAULT_SIZE.noticeBoard.minSizeY,
          maxH: DEFAULT_SIZE.noticeBoard.maxSizeY,
          ...data,
          widget: widgetId,
        };
        newcomponents.splice(index, 0, newItem);
        //移动端进行过排序，将值追加到最后加上H值

        if (isIphoneSort) {
          const entries = Object.entries(mobileSortedObjMapsSrot);
          const lastEntry = entries[entries.length - 1];
          newItem.y = lastEntry[1].h + lastEntry[1].y;
          mobileSortedObjMapsSrot.push(newItem);
        } else {
          mobileSortedObjMapsSrot.splice(index, 0, newItem);
        }
        mobileComponentsMaps[widgetId] = newItem;
        mobile.splice(index, 0, {
          widget: newItem.widget,
          id: data.id,
          enable: true,
        });
        newcomponents.map((res) => {
          res.x = xyMAP[res.i || res.widget].x;
          res.y = xyMAP[res.i || res.widget].y;
        });
        const { mobileComponents } = BsyUtils.getSurplusMobileDash(
          this.deepCopy(newcomponents),
          customDash.dash
        );

        this.setState(
          {
            components: [...newcomponents],
            mobileComponents: [...mobileComponents],
            mobileComponentsMaps: mobileComponentsMaps,
            mobileSortedObjMaps: mobileSortedObjMapsSrot,
            mobile: mobile,
            iphoneSortTianyong: this.addIphoneWeight(
              data.id,
              mobileComponentsMaps
            ),
          },
          () => {
            this.checkListStatus();
          }
        );
        break;
      }
      case "richText": {
        const newcomponents = [...components];
        const newItem = {
          x: 0,
          y: i.y,
          w: DEFAULT_SIZE.richText.defaultSizeX,
          h: DEFAULT_SIZE.richText.defaultSizeY,
          minW: DEFAULT_SIZE.richText.minSizeX,
          minH: DEFAULT_SIZE.richText.minSizeY,
          maxH: DEFAULT_SIZE.richText.maxSizeY,
          ...data,
          widget: widgetId,
        };
        if (isIphoneSort) {
          const entries = Object.entries(mobileSortedObjMapsSrot);
          const lastEntry = entries[entries.length - 1];
          newItem.y = lastEntry[1].h + lastEntry[1].y;
          mobileSortedObjMapsSrot.push(newItem);
        } else {
          mobileSortedObjMapsSrot.splice(index, 0, newItem);
        }
        newcomponents.splice(index, 0, newItem);
        mobileComponentsMaps[widgetId] = newItem;
        mobile.splice(index, 0, {
          widget: newItem.widget,
          id: data.id,
          enable: true,
        });
        newcomponents.map((res) => {
          res.x = xyMAP[res.i || res.widget].x;
          res.y = xyMAP[res.i || res.widget].y;
        });
        const { mobileComponents } = BsyUtils.getSurplusMobileDash(
          this.deepCopy(newcomponents),
          customDash.dash
        );

        this.setState(
          {
            components: [...newcomponents],
            mobileComponents: [...mobileComponents],
            mobileComponentsMaps: mobileComponentsMaps,
            mobileSortedObjMaps: mobileSortedObjMapsSrot,
            mobile: mobile,
            iphoneSortTianyong: this.addIphoneWeight(
              data.id,
              mobileComponentsMaps
            ),
          },
          () => {
            this.checkListStatus();
          }
        );
        break;
      }
      case "dockApp": {
        //外部应用
        const newcomponents = [...components];
        const newItem = {
          x: 0,
          y: i.y,
          w: DEFAULT_SIZE.dockApp.defaultSizeX,
          h: DEFAULT_SIZE.dockApp.defaultSizeY,
          minW: DEFAULT_SIZE.dockApp.minSizeX,
          minH: DEFAULT_SIZE.dockApp.minSizeY,
          maxH: DEFAULT_SIZE.dockApp.maxSizeY,
          ...data,
          widget: widgetId,
        };
        newcomponents.splice(index, 0, newItem);
        mobileComponentsMaps[widgetId] = newItem;
        mobile.splice(index, 0, {
          widget: newItem.widget,
          id: data.id,
          enable: true,
        });
        newcomponents.map((res) => {
          res.x = xyMAP[res.i || res.widget].x;
          res.y = xyMAP[res.i || res.widget].y;
        });
        const { mobileComponents } = BsyUtils.getSurplusMobileDash(
          this.deepCopy(newcomponents),
          customDash.dash
        );
        this.setState(
          {
            components: [...newcomponents],
            mobileComponents: [...mobileComponents],
            mobileComponentsMaps: mobileComponentsMaps,
            mobile: mobile,
          },
          () => {
            this.checkListStatus();
          }
        );
        break;
      }
      case "customDash": {
        //报表看板
        // let x = 0;
        // if (j1.length > 0) {
        //     let dd = j1[j1.length - 1];
        //     if (dd.w + dd.x + DEFAULT_SIZE.customDash.defaultSizeX > 60) {
        //         x = 0
        //     } else {
        //         x = dd.w + dd.x
        //     }
        // }

        let block = {
          x: i.x,
          y: i.y,
          w: DEFAULT_SIZE.customDash.defaultSizeX,
          h: DEFAULT_SIZE.customDash.defaultSizeY,
          minW: DEFAULT_SIZE.customDash.minSizeX,
          minH: DEFAULT_SIZE.customDash.minSizeY,
          maxH: DEFAULT_SIZE.customDash.maxSizeY,
          maxW: DEFAULT_SIZE.customDash.maxSizeX,
          ...data,
          widget: widgetId,
        };

        BsyDialog({
          title: data.name + React.language("setting"),
          height: 450,
          width: 500,
          noFooter: false,
          okText: React.language("ok"),
          cancelText: React.language("cancel"),
          onOk: () => {
            if (!this.block) {
              tipAlert({
                type: "warning",
                msg: React.language("dash.not.select"),
              });
              return false;
            }
            if (!this.block.widgetId) {
              tipAlert({
                type: "warning",
                msg: React.language("dash.not.select"),
              });
              return false;
            }
            this.block.x = block.x;
            this.block.y = block.y;

            const newcomponents = [...components, this.block];

            mobileComponentsMaps[widgetId] = this.block;

            if (isIphoneSort) {
              const entries = Object.entries(mobileSortedObjMapsSrot);
              const lastEntry = entries[entries.length - 1];
              mobileComponentsMaps[widgetId].y =
                lastEntry[1].h + lastEntry[1].y;
              mobileSortedObjMapsSrot.push(mobileComponentsMaps[widgetId]);
            } else {
              mobileSortedObjMapsSrot.splice(
                index,
                0,
                mobileComponentsMaps[widgetId]
              );
            }
            newcomponents.map((res) => {
              res.x = xyMAP[res.i || res.widget].x;
              res.y = xyMAP[res.i || res.widget].y;
            });
            mobile.push({
              widget: this.block.widget,
              widgetId: this.block.widgetId,
              id: data.id,
              enable: true,
            });
            const n = newcomponents.sort((s, j) => {
              return s.y - j.y;
            });
            const { mobileComponents } = BsyUtils.getSurplusMobileDash(
              this.deepCopy(newcomponents),
              this.customDash.dash
            );
            this.setState(
              {
                components: [...n],
                customDash: { ...this.customDash },
                mobileComponents: [...mobileComponents],
                mobileComponentsMaps: mobileComponentsMaps,
                mobileSortedObjMaps: mobileSortedObjMapsSrot,
                mobile: mobile,
                iphoneSortTianyong: this.addIphoneWeight(
                  data.id,
                  mobileComponentsMaps
                ),
              },
              () => {
                this.checkListStatus();
              }
            );
          },
          onContentCreate: () => {
            return (
              <BsyDashboardCustomDashConfig
                customDash={customDash}
                block={block}
                getValue={this.CustomDashValue}
              />
            );
          },
        });
        break;
      }
      case "filterBtn": {
        const newcomponents = [...components];
        const newItem = {
          x: 0,
          y: i.y,
          w: 15,
          h: 6,
          minW: 10,
          minH: 6,
          ...data,
          widget: widgetId,
        };
        newcomponents.splice(index, 0, newItem);
        mobileComponentsMaps[widgetId] = newItem;
        mobile.splice(index, 0, {
          widget: newItem.widget,
          id: data.id,
          enable: true,
        });
        newcomponents.map((res) => {
          res.x = xyMAP[res.i || res.widget].x;
          res.y = xyMAP[res.i || res.widget].y;
        });
        const { mobileComponents } = BsyUtils.getSurplusMobileDash(
          this.deepCopy(newcomponents),
          customDash.dash
        );
        this.setState(
          {
            components: [...newcomponents],
            mobileComponents: [...mobileComponents],
            mobileComponentsMaps: mobileComponentsMaps,
            mobile: mobile,
          },
          () => {
            this.checkListStatus();
          }
        );
        break;
      }
      case "carouselMap": {
        const newcomponents = [...components];
        const newItem = {
          x: 0,
          y: i.y,
          w: DEFAULT_SIZE.carouselMap.defaultSizeX,
          h: DEFAULT_SIZE.carouselMap.defaultSizeY,
          minW: DEFAULT_SIZE.carouselMap.minSizeX,
          minH: DEFAULT_SIZE.carouselMap.minSizeY,
          maxH: DEFAULT_SIZE.carouselMap.maxSizeY,
          ...data,
          widget: widgetId,
        };
        newcomponents.splice(index, 0, newItem);
        if (isIphoneSort) {
          const entries = Object.entries(mobileComponentsMaps);
          const lastEntry = entries[entries.length - 1];
          newItem.y = lastEntry[1].h + lastEntry[1].y;
          mobileSortedObjMaps.push(newItem);
        } else {
          mobileSortedObjMaps.splice(index, 0, newItem);
        }
        mobileComponentsMaps[widgetId] = newItem;
        mobile.splice(index, 0, {
          widget: newItem.widget,
          id: data.id,
          enable: true,
        });
        newcomponents.map((res) => {
          res.x = xyMAP[res.i || res.widget].x;
          res.y = xyMAP[res.i || res.widget].y;
        });
        const { mobileComponents } = BsyUtils.getSurplusMobileDash(
          this.deepCopy(newcomponents),
          customDash.dash
        );

        this.setState(
          {
            components: [...newcomponents],
            mobileComponents: [...mobileComponents],
            mobileComponentsMaps: mobileComponentsMaps,
            mobile: mobile,
            iphoneSortTianyong: this.addIphoneWeight(
              data.id,
              mobileComponentsMaps
            ),
          },
          () => {
            this.checkListStatus();
          }
        );
        break;
        // BsyDialog({
        //   title: data.name + React.language("setting"),
        //   // height: 450,
        //   width: 520,
        //   noFooter: false,
        //   customCls: "t-carouse-map-dialog",
        //   okText: React.language("ok"),
        //   cancelText: React.language("cancel"),
        //   onOk: () => {
        //     const newcomponents = [...components];
        //     const newItem = {
        //       x: 0,
        //       y: i.y,
        //       w: DEFAULT_SIZE.carouselMap.defaultSizeX,
        //       h: DEFAULT_SIZE.carouselMap.defaultSizeY,
        //       minW: DEFAULT_SIZE.carouselMap.minSizeX,
        //       minH: DEFAULT_SIZE.carouselMap.minSizeY,
        //       maxH: DEFAULT_SIZE.carouselMap.maxSizeY,
        //       ...data,
        //       widget: widgetId,
        //     };
        //     newcomponents.splice(index, 0, newItem);
        //     mobileComponentsMaps[widgetId] = newItem;
        //     mobile.splice(index, 0, {
        //       widget: newItem.widget,
        //       id: data.id,
        //       enable: true,
        //     });
        //     newcomponents.map((res) => {
        //       res.x = xyMAP[res.i || res.widget].x;
        //       res.y = xyMAP[res.i || res.widget].y;
        //     });
        //     const { mobileComponents } = BsyUtils.getSurplusMobileDash(
        //       this.deepCopy(newcomponents),
        //       customDash.dash
        //     );

        //     this.setState(
        //       {
        //         components: [...newcomponents],
        //         mobileComponents: [...mobileComponents],
        //         mobileComponentsMaps: mobileComponentsMaps,
        //         mobile: mobile,
        //         iphoneSortTianyong: this.addIphoneWeight(
        //           data.id,
        //           mobileComponentsMaps
        //         ),
        //         carouselMap:
        //           this.bsyDashboardCarouselMapConfig.current.emitData(),
        //       },
        //       () => {
        //         this.checkListStatus();
        //       }
        //     );
        //   },
        //   onContentCreate: () => {
        //     return (
        //       <BsyDashboardCarouselMapConfig
        //         ref={this.bsyDashboardCarouselMapConfig}
        //       />
        //     );
        //   },
        // });
        // break;
      }
      default: {
        // this.setState({});
      }
    }

    if (data.id.includes("speedyEntryV2")) {
      const newcomponents = [...components];
      const newItem = {
        x: 0,
        y: i.y,
        w: DEFAULT_SIZE.speedyEntryV2.defaultSizeX,
        h: DEFAULT_SIZE.speedyEntryV2.defaultSizeY,
        minW: DEFAULT_SIZE.speedyEntryV2.minSizeX,
        minH: DEFAULT_SIZE.speedyEntryV2.minSizeY,
        maxH: DEFAULT_SIZE.speedyEntryV2.maxSizeY,
        ...data,
        widget: widgetId,
      };
      if (isIphoneSort) {
        const entries = Object.entries(mobileSortedObjMapsSrot);
        const lastEntry = entries[entries.length - 1];
        newItem.y = lastEntry[1].h + lastEntry[1].y;
        mobileSortedObjMapsSrot.push(newItem);
      } else {
        mobileSortedObjMapsSrot.splice(index, 0, newItem);
      }

      newcomponents.splice(index, 0, newItem);
      mobileComponentsMaps[widgetId] = newItem;
      mobile.splice(index, 0, {
        widget: newItem.widget,
        id: data.id,
        enable: true,
      });
      newcomponents.map((res) => {
        res.x = xyMAP[res.i || res.widget].x;
        res.y = xyMAP[res.i || res.widget].y;
      });

      const { mobileComponents } = BsyUtils.getSurplusMobileDash(
        this.deepCopy(newcomponents),
        customDash.dash
      );

      preferences[this.currentDragElData.id] = {
        title: React.language("speedy.entry"),
        enable: true,
        seq: 3,
        entries: [],
        layoutStyle: "list",
      };
      this.setState(
        {
          components: [...newcomponents],
          mobileComponents: [...mobileComponents],
          mobileComponentsMaps: mobileComponentsMaps,
          mobileSortedObjMaps: mobileSortedObjMapsSrot,
          mobile: mobile,
          preferences: preferences,
          iphoneSortTianyong: this.addIphoneWeight(
            data.id,
            mobileComponentsMaps
          ),
        },
        () => {
          this.checkListStatus();
        }
      );
    }
  };
  renderTltleHtml = (block) => {
    switch (block.id) {
      case "myApp":
        return (
          <>
            <i className="icon-new-wdyy"></i> <span>{block.name}</span>
          </>
        );
      case "flowManagementV2":
        return (
          <>
            <i className="icon-new-lcdb"></i> <span>{block.name}</span>
          </>
        );
      case "dockApp":
        return (
          <>
            <i className="icon-new-wbyy"></i> <span>{block.name}</span>
          </>
        );
      case "customDash":
        return (
          <>
            <i className="icon-new-bbkb"></i> <span>{block.name}</span>
          </>
        );
      case "carouselMap":
        return (
          <>
            <i className="icon-new-lbt"></i> <span>{block.name}</span>
          </>
        );
      case "recentUse":
        return (
          <>
            <i className="icon-new-zusy"></i> <span>{block.name}</span>
          </>
        );
      case "noticeBoard":
        return (
          <>
            <i className="icon-new-ggl"></i> <span>{block.name}</span>
          </>
        );
      case "myDash":
        return (
          <>
            <i className="icon-new-wdtb"></i> <span>{block.name}</span>
          </>
        );
      case "favorites":
        return (
          <>
            <i className="icon-new-wdsc"></i> <span>{block.name}</span>
          </>
        );
      case "richText":
        return (
          <>
            <i className="icon-new-fwb"></i> <span>{block.name}</span>
          </>
        );
      default:
        {
        }
        if (block.id.includes("speedyEntryV2")) {
          return (
            <>
              <i className="icon-new-kjrk"></i> <span>{block.name}</span>
            </>
          );
        }
    }
  };
  addIphoneWeight = (id, mobileComponentsMaps) => {
    //手机端添加
    let iphoneSortTianyong = this.state.iphoneSortTianyong;
    let keys = Object.keys(mobileComponentsMaps);
    let lastKeys = keys.pop();
    iphoneSortTianyong.push({
      enable: true,
      id: id,
      widget: mobileComponentsMaps[lastKeys].widget,
      widgetId: mobileComponentsMaps[lastKeys].widgetId,
    });
    return iphoneSortTianyong;
  };
  checkListStatus = () => {
    const { list, components, preferences, customDash } = this.state;

    let disableList = [
      "flowManagement",
      "flowManagementV2",
      "speedyEntry",
      // 'speedyEntryV2',
      "customApp",
      "dockApp",
      "myApp",
      "myDash",
      "favorites",
      "carouselMap",
      "richText",
      "recentUse",
      "noticeBoard",
    ];

    const check = (id) => {
      if (!disableList.includes(id)) {
        return false;
      }
      // if(Object.getOwnPropertyNames(preferences).length>=2){
      //     return true
      // }

      const block = components.find((block) => {
        return id === block.id;
      });
      return block ? true : false;
    };
    const newList = list.map((data) => {
      data.disable = check(data.id);
      if (
        data.id.includes("speedyEntryV2") &&
        Object.getOwnPropertyNames(preferences).length >= 8
      ) {
        data.disable = true;
      }
      if (data.id === "customDash" && customDash.dash.length >= 20) {
        data.disable = true;
      }
      return data;
    });
    // components.map((block) => {

    //     if ('flowManagement' === block.id || 'flowManagementV2' === block.id) {
    //         newList[0].disable = true;
    //     }
    //     if ('speedyEntry' === block.id || 'speedyEntryV2' === block.id) {
    //         newList[1].disable = true;
    //     }
    //     if ('customApp' === block.id) {
    //         newList[2].disable = true;
    //     }
    //     if ('dockApp' === block.id) {
    //         newList[3].disable = true;
    //     }
    //     if ('myApp' === block.id) {
    //         newList[5].disable = true;
    //     }
    //     if ('carouselMap' === block.id) {
    //         newList[6].disable = true;
    //     }
    //     if ('recentUse' === block.id) {
    //         newList[7].disable = true;
    //     }
    //     if ('noticeBoard' === block.id) {
    //         newList[8].disable = true;
    //     }

    //     // if ('myDash' === block.id) {
    //     //     newList[5].disable = true;
    //     // }
    //     return !1
    // })
    this.setState({
      list: newList,
    });
  };

  delComponents = (block) => {
    const {
      components,
      customDash,
      mobileComponents,
      mobile,
      preferences,
      mobileComponentsMaps,
      iphoneSortTianyong,
      mobileSortedObjMaps,
    } = this.state;
    let setSpeedyEntry = this.state.speedyEntry;
    let noticeBoard = this.state.noticeBoard;
    let richText = this.state.richText;
    let carouselMap = this.state.carouselMap;
    // 手机端对应的组件也要删除 通过ID 会删除整个类型的所有组件
    let iphoneSortTianyongOl = iphoneSortTianyong.filter((item) => {
      return item.widget !== block.widget;
    });

    let mobileSortedObjMapsOl = mobileSortedObjMaps.filter((item) => {
      return item.widget !== block.widget;
    });
    if (block.id.includes("speedyEntryV2")) {
      //快捷入口删除的时候list也要删除
      delete preferences[block.id];
    }
    if (block.id === "noticeBoard") {
      //公告栏删除的时候list也要删除
      noticeBoard = {};
    }
    if (block.id === "richText") {
      //富文本删除的时候 对应数据也要删除
      richText = {};
    }
    if (block.id === "carouselMap") {
      //轮播图删除的时候 对应数据也要删除
      carouselMap = {};
    }
    const lgs = components.filter((data) => {
      return data.widget !== block.widget;
    });
    mobileComponentsMaps[block.widget] &&
      delete mobileComponentsMaps[block.widget];

    const mlgs = mobileComponents.filter((data) => {
      return data.widget !== block.widget;
    });

    const mlgs1 = mobile.filter((data) => {
      return data.widget !== block.widget;
    });

    let widget = [];

    BsyUtils.forEach(customDash.dash, (index, data) => {
      if (
        [data.appId, data.entryId, data.widgetId].join("@") !==
        [block.appId, block.entryId, block.widgetId].join("@")
      ) {
        widget.push(data);
      }
    });
    this.setState(
      {
        components: [...lgs],
        mobile: [...mlgs1],
        mobileComponentsMaps: mobileComponentsMaps,
        mobileSortedObjMaps: mobileSortedObjMapsOl,
        iphoneSortTianyong: iphoneSortTianyongOl,
        mobileComponents: [...mlgs],
        customDash: {
          ...customDash,
          dash: widget,
        },
        speedyEntry: setSpeedyEntry,
        preferences: preferences,
        noticeBoard: noticeBoard,
        carouselMap: carouselMap,
        richText: richText,
      },
      () => {
        this.checkListStatus();
      }
    );
  };

  onFlowManagement = (layout) => {
    const { components } = this.state;
    const newcomponents = [...components].map((block) => {
      if (block.widget === layout.widget) {
        if (!block.layout || block.layout === "horizontal") {
          block.layout = "vertical";
          block.w = DEFAULT_SIZE.flowManagement.vertical.defaultSizeX;
          block.h = DEFAULT_SIZE.flowManagement.vertical.defaultSizeY;
        } else {
          block.layout = "horizontal";
          block.w = DEFAULT_SIZE.flowManagement.horizontal.defaultSizeX;
          block.h = DEFAULT_SIZE.flowManagement.horizontal.defaultSizeY;
        }
        block.widget = this.generateWidget();
      }
      return block;
    });
    this.setState(
      {
        components: [...newcomponents],
      },
      () => {
        this.checkListStatus();
      }
    );
  };

  onSpeedyEntry = (c) => {
    let { preferences, components, recentUse } = this.state;
    preferences = {
      ...preferences,
      ...c,
    };
    this.setState({
      preferences: { ...preferences },
      components: this.setSpeedyEntryGrid(components, preferences, recentUse),
    });
  };
  onEmitCarousel = (c) => {
    let { carouselMap } = this.state;
    carouselMap = {
      ...carouselMap,
      ...c,
    };
    this.setState({
      carouselMap: { ...carouselMap },
    });
  };
  onEmitSaveBoardNotice = (c) => {
    let { noticeBoard } = this.state;
    let list = JSON.parse(JSON.stringify(this.state.components));
    list.forEach((item) => {
      if (item.id === "noticeBoard" && c.styleType === "one") {
        item.minW = 20;
        item.w = c.gridW < 20 ? 20 : c.gridW;
        item.h = 8;
        item.maxH = 8;
        item.minH = 8;
      }
      if (item.id === "noticeBoard" && c.styleType === "two" && c.dataSource === "staticDataSource"
      ) {
        item.minW = 20;
        item.w = c.gridW < 20 ? 20 : c.gridW;
        item.h = 8;
        item.maxH = 8;
        item.minH = 8;
        // switch (c.noticeListStatic.length) {
        //   case 0:
        //   case 1: item.minW = 20;
        //     item.w = c.gridW < 20 ? 20 : c.gridW;
        //     item.h = 8;
        //     item.maxH = 8;
        //     item.minH = 8;
        //     break;
        //   case 2:
        //     item.minW = 20;
        //     item.w = c.gridW < 20 ? 20 : c.gridW;
        //     item.h = (c.isShowTitle || c.isShowMoreTitle) ? 9 : 8;
        //     item.maxH = (c.isShowTitle || c.isShowMoreTitle) ? 9 : 8;
        //     item.minH = (c.isShowTitle || c.isShowMoreTitle) ? 9 : 8;
        //     break;
        //   case 3:
        //   case 4:
        //   case 5:
        //   case 6:
        //     item.minW = 20;
        //     item.w = c.gridW < 20 ? 20 : c.gridW;
        //     item.h = 8;
        //     item.maxH = 8;
        //     item.minH = 8;
        //     break;
        //   default: {
        //   }
        // }
      }
      if (item.id === "noticeBoard" && c.styleType === "two" && c.dataSource === "dynamicDataSource"
      ) {
        item.minW = 20;
        item.w = c.gridW < 20 ? 20 : c.gridW;
        item.h = 8;
        item.maxH = 8;
        item.minH = 8;
        // switch (c.noticeListDynamic.length) {
        //   case 0:
        //   case 1: item.minW = 20;
        //     item.w = c.gridW < 20 ? 20 : c.gridW;
        //     item.h = 8;
        //     item.maxH = 8;
        //     item.minH = 8;
        //     break;
        //   case 2:
        //     item.minW = 20;
        //     item.w = c.gridW < 20 ? 20 : c.gridW;
        //     item.h = (c.isShowTitle || c.isShowMoreTitle) ? 9 : 8;
        //     item.maxH = (c.isShowTitle || c.isShowMoreTitle) ? 9 : 8;
        //     item.minH = (c.isShowTitle || c.isShowMoreTitle) ? 9 : 8;
        //     break;
        //   case 3:
        //   case 4:
        //   case 5:
        //   case 6:
        //     item.minW = 20;
        //     item.w = c.gridW < 20 ? 20 : c.gridW;
        //     item.h = 8;
        //     item.maxH = 8;
        //     item.minH = 8;
        //     break;
        //   default: {
        //   }
        // }
      }
      if (item.id === "noticeBoard" && c.styleType === "three" && c.dataSource === "dynamicDataSource"
      ) {
        switch (c.noticeListDynamic.length) {
          case 0:
          case 1:
            item.minW = 10;
            item.w = c.gridW < 10 ? 10 : c.gridW;
            item.h = 3;
            item.maxH = 3;
            item.minH = 3;
            break;

          case 2:
            item.minW = 10;
            item.w = c.gridW < 10 ? 10 : c.gridW;
            item.h = 4;
            item.maxH = 4;
            item.minH = 4;
            break;
          case 3:
            item.minW = 10;
            item.w = c.gridW < 10 ? 10 : c.gridW;
            item.h = 5;
            item.maxH = 5;
            item.minH = 5;
            break;
          case 4:
            item.minW = 10;
            item.w = c.gridW < 10 ? 10 : c.gridW;
            item.h = 6;
            item.maxH = 6;
            item.minH = 6;
            break;
          case 5:
            item.minW = 10;
            item.w = c.gridW < 10 ? 10 : c.gridW;
            item.h = (c.isShowTitle || c.isShowMoreTitle) ? 7 : 6;
            item.maxH = (c.isShowTitle || c.isShowMoreTitle) ? 7 : 6;
            item.minH = (c.isShowTitle || c.isShowMoreTitle) ? 7 : 6;
            break;
          case 6:
            item.minW = 10;
            item.w = c.gridW < 10 ? 10 : c.gridW;
            item.h = (c.isShowTitle || c.isShowMoreTitle) ? 8 : 7;
            item.maxH = (c.isShowTitle || c.isShowMoreTitle) ? 8 : 7;
            item.minH = (c.isShowTitle || c.isShowMoreTitle) ? 8 : 7;
            break;
          default: {
          }
        }
      }
      if (item.id === "noticeBoard" && c.styleType === "three" && c.dataSource === "staticDataSource"
      ) {
        switch (c.noticeListStatic.length) {
          case 0:
          case 1:
            item.minW = 10;
            item.w = c.gridW < 10 ? 10 : c.gridW;
            item.h = 3;
            item.maxH = 3;
            item.minH = 3;
            break;

          case 2:
            item.minW = 10;
            item.w = c.gridW < 10 ? 10 : c.gridW;
            item.h = 4;
            item.maxH = 4;
            item.minH = 4;
            break;
          case 3:
            item.minW = 10;
            item.w = c.gridW < 10 ? 10 : c.gridW;
            item.h = 5;
            item.maxH = 5;
            item.minH = 5;
            break;
          case 4:
            item.minW = 10;
            item.w = c.gridW < 10 ? 10 : c.gridW;
            item.h = 6;
            item.maxH = 6;
            item.minH = 6;
            break;
          case 5:
            item.minW = 10;
            item.w = c.gridW < 10 ? 10 : c.gridW;
            item.h = (c.isShowTitle || c.isShowMoreTitle) ? 7 : 6;
            item.maxH = (c.isShowTitle || c.isShowMoreTitle) ? 7 : 6;
            item.minH = (c.isShowTitle || c.isShowMoreTitle) ? 7 : 6;
            break;
          case 6:
            item.minW = 10;
            item.w = c.gridW < 10 ? 10 : c.gridW;
            item.h = (c.isShowTitle || c.isShowMoreTitle) ? 8 : 7;
            item.maxH = (c.isShowTitle || c.isShowMoreTitle) ? 8 : 7;
            item.minH = (c.isShowTitle || c.isShowMoreTitle) ? 8 : 7;
            break;
          default: {
          }
        }
      }
    });
    noticeBoard = {
      ...noticeBoard,
      ...c,
    };
    this.setState({
      noticeBoard: { ...noticeBoard },
      components: list,
    });
  };
  onEmitRecentUseValue = (c) => {
    let { recentUse } = this.state;
    recentUse = {
      ...recentUse,
      ...c,
    };
    this.setState({
      recentUse: { ...recentUse },
    });
  };
  onEmitFlowManagementType = (type) => {
    let list = JSON.parse(JSON.stringify(this.state.components));

    this.setState({
      flowManagementType: type,
      components: list.map((item) => {
        if (item.id === "flowManagementV2") {
          if (type === "combo") {
            item.minW = 12;
            item.w = 12;
            item.h = 8;
            item.maxH = 8;
            item.minH = 8;
          }
          if (type === "card-vertical") {
            item.minW = 40;
            item.w = 40;
            item.h = 8;
            item.maxH = 8;
            item.minH = 8;
          }
          if (type === "card-cross") {
            item.minW = 52;
            item.w = 60;
            item.h = 6;
            item.maxH = 6;
            item.minH = 6;
          }
        }
        return item;
      }),
    });
  };
  onMyApp = (c) => {
    let { myApp } = this.state;
    myApp = {
      ...myApp,
      ...c,
    };
    this.setState({
      myApp: { ...myApp },
    });
  };

  onCustomApp = (c) => {
    let { customApp } = this.state;
    customApp = {
      ...customApp,
      ...c,
    };
    this.setState({
      customApp: { ...customApp },
    });
  };

  onDockApp = (c) => {
    let { dockApp } = this.state;
    dockApp = {
      ...dockApp,
      ...c,
    };
    this.setState({
      dockApp: { ...dockApp },
    });
  };

  onSave = (layout, cd) => {
    const {
      selectDesignType,
      components,
      selectDesignId,
      preferences,
      mobileComponents,
      mobile,
      speedyEntry,
      customDash,
      carouselMap,
      recentUse,
      noticeBoard,
      mobileSortedObjMaps,
      isIphoneSort,
      richText,
      iphoneSortTianyong,
      flowManagementType,
    } = this.state;
    let bakcomponents = components.sort((s, j) => {
      return s.y - j.y;
    });

    if (navigator.userAgent.indexOf("Firefox") > -1) {
      bakcomponents = bakcomponents.reverse();
    }

    let bakMobileComponents = mobileComponents.sort((s, j) => {
      return s.y - j.y;
    });

    if (navigator.userAgent.indexOf("Firefox") > -1) {
      bakMobileComponents = bakMobileComponents.reverse();
    }

    const nMobile = [];
    const nM = {};
    mobile.map((res) => {
      nM[res.widget] = res;
    });
    bakMobileComponents.map((res) => {
      if (res.id === "customDash") {
        nMobile.push({
          widget: res.widget,
          widgetId: res.widgetId,
          id: res.id,
          enable: nM[res.widget]
            ? nM[res.widget].hasOwnProperty("enable")
              ? nM[res.widget].enable
              : true
            : true,
        });
      } else {
        nMobile.push({
          widget: res.widget,
          id: res.id,
          enable: nM[res.widget]
            ? nM[res.widget].hasOwnProperty("enable")
              ? nM[res.widget].enable
              : true
            : true,
        });
      }
    });

    let flowManagement = {};
    let customAppList = { apps: [] };
    let dockAppList = { corp: "" };
    !BsyUtils.isObjectEmpty(this.state.customApp) &&
      this.state.customApp.apps.map((res) => {
        customAppList.apps.push(res._id);
      });
    this.state.dockApp && (dockAppList.corp = this.state.dockApp.corp);

    let seq = 0;
    let dashSeq = 0;
    flowManagement.enable = false;
    speedyEntry.enable = false;
    customAppList.enable = false;
    dockAppList.enable = false;
    customDash.enable = false;
    carouselMap.enable = false;
    recentUse.enable = false;
    noticeBoard.enable = false;
    richText.enable = false;
    nMobile.map((res) => {
      if (
        res.id === "flowManagement" ||
        res.id === "flowManagementV2" ||
        res.id === "speedyEntry" ||
        res.id.includes("speedyEntryV2") ||
        res.id === "customApp" ||
        res.id === "dockApp" ||
        res.id === "carouselMap" ||
        res.id === "recentUse" ||
        res.id === "noticeBoard" ||
        res.id === "richText" ||
        res.id === "myDash"
      ) {
        seq++;
      }

      if (res.id === "flowManagement" || res.id === "flowManagementV2") {
        flowManagement.enable = res.enable;
      }

      if (res.id === "speedyEntry" || res.id === "speedyEntryV2") {
        speedyEntry.seq = seq;
        speedyEntry.enable = res.enable;
      }

      if (res.id.includes("speedyEntryV2")) {
        preferences[res.id].seq = seq;
        preferences[res.id].enable = res.enable;
      }
      if (res.id === "customApp") {
        customAppList.seq = seq;
        customAppList.enable = res.enable;
      }

      if (res.id === "carouselMap") {
        carouselMap.seq = seq;
        carouselMap.enable = res.enable;
      }
      if (res.id === "recentUse") {
        recentUse.seq = seq;
        recentUse.enable = res.enable;
      }
      if (res.id === "noticeBoard") {
        noticeBoard.seq = seq;
        noticeBoard.enable = res.enable;
      }
      if (res.id === "richText") {
        richText.seq = seq;
        richText.enable = res.enable;
      }

      if (res.id === "dockApp") {
        dockAppList.seq = seq;
        dockAppList.enable = res.enable;
      }
      if (res.id === "customDash") {
        dashSeq++;
      }
      return null;
    });
    customDash.enable = dashSeq !== 0;
    customDash.seq = 10;

    let layerRef = null;
    BsyMaskLayer({
      customCls: "hasBackground",
      onContentCreate: (ref) => {
        layerRef = ref;
        return (
          <div>
            <BsySLoading />
          </div>
        );
      },
    });

    React.axios("/corp/update_custom", {
      mode: selectDesignType !== "company" ? "custom" : "default",
      layout: {
        enable: layout === "close" ? false : true,
        pc: bakcomponents,

        mobile: iphoneSortTianyong,
        mobileLayout: mobileSortedObjMaps,
      },
      id: selectDesignId,
      flowManagement: flowManagement,
      customApp: customAppList,
      flowManagementType: flowManagementType,
      carouselMap: carouselMap,
      recentUse: recentUse,
      isIphoneSort: isIphoneSort || false,
      richText: richText,
      noticeBoard: noticeBoard,
      dockApp: dockAppList,
      customDash: customDash,
      // speedyEntry: speedyEntry,
      preferences: JSON.parse(JSON.stringify(preferences)),
    })
      .then(() => {
        this.oldComponents = bakcomponents;
        if (layout === "close") {
          tipAlert({
            type: "success",
            msg: React.language("operationSuccess"),
          });
          this.props.history.push("/team");
        } else {
          tipAlert({
            type: "success",
            msg: React.language("saveInfo.success"),
          });
        }
        layerRef && layerRef.close();
        cd && cd();
      })
      .catch(() => {
        layerRef && layerRef.close();
      });
  };

  getComponentsSize = (block) => {
    const { flowManagementType } = this.state;
    switch (block.id) {
      case "flowManagement": {
        if (!block.layout) {
          block.layout = "horizontal";
        }
        return {
          x: 0,
          y: Infinity,
          w: DEFAULT_SIZE.flowManagement.horizontal.defaultSizeX,
          h: DEFAULT_SIZE.flowManagement.horizontal.defaultSizeY,
          minW: DEFAULT_SIZE.flowManagement[block.layout].minSizeX,
          minH: DEFAULT_SIZE.flowManagement[block.layout].minSizeY,
          maxW: DEFAULT_SIZE.flowManagement[block.layout].maxSizeX,
          maxH: DEFAULT_SIZE.flowManagement[block.layout].maxSizeY,
        };
      }
      case "flowManagementV2": {
        if (!block.layout) {
          block.layout = "horizontal";
        }
        if (block.layout === "vertical") {
          // 新版没有 vertical了
          block.layout = "horizontal";
        }
        return {
          x: 0,
          y: Infinity,
          w: DEFAULT_SIZE.flowManagementV2.horizontal.defaultSizeX,
          h:
            flowManagementType === "card-cross" || !flowManagementType
              ? DEFAULT_SIZE.flowManagementV2.horizontal.defaultSizeY
              : DEFAULT_SIZE.flowManagementV2[flowManagementType].defaultSizeY,
          minW:
            flowManagementType === "card-cross" || !flowManagementType
              ? DEFAULT_SIZE.flowManagementV2[block.layout].minSizeX
              : DEFAULT_SIZE.flowManagementV2[flowManagementType].minSizeX,
          minH:
            flowManagementType === "card-cross" || !flowManagementType
              ? DEFAULT_SIZE.flowManagementV2[block.layout].minSizeY
              : DEFAULT_SIZE.flowManagementV2[flowManagementType].minSizeY,
          maxW: DEFAULT_SIZE.flowManagementV2[block.layout].maxSizeX,
          maxH:
            flowManagementType === "card-cross" || !flowManagementType
              ? DEFAULT_SIZE.flowManagementV2[block.layout].maxSizeY
              : DEFAULT_SIZE.flowManagementV2[flowManagementType].maxSizeY,
        };
      }
      case "leftComponents":
      case "rightComponents":
      case "oddComponents":
      case "tabComponents": {
        return {
          x: 0,
          y: Infinity,
          w: DEFAULT_SIZE.flowManagement.horizontal.defaultSizeX,
          h: DEFAULT_SIZE.flowManagement.horizontal.defaultSizeY,
          minW: DEFAULT_SIZE.flowManagement.horizontal.minSizeX,
          minH: DEFAULT_SIZE.flowManagement.horizontal.minSizeY,
          maxH: DEFAULT_SIZE.flowManagement.horizontal.maxSizeY,
        };
      }
      case "favorites": {
        return {
          x: 0,
          y: Infinity,
          w: DEFAULT_SIZE.favorites.defaultSizeX,
          h: DEFAULT_SIZE.favorites.defaultSizeY,
          minW: DEFAULT_SIZE.favorites.minSizeX,
          minH: DEFAULT_SIZE.favorites.minSizeY,
          maxW: DEFAULT_SIZE.favorites.maxSizeX,
          maxH: DEFAULT_SIZE.favorites.maxSizeY,
        };
      }
      case "myDash": {
        if (!block.layout) {
          block.layout = "horizontal";
        }
        return {
          x: 0,
          y: Infinity,
          w: DEFAULT_SIZE.myDash.defaultSizeX,
          h: DEFAULT_SIZE.myDash.defaultSizeY,
          minW: DEFAULT_SIZE.myDash.minSizeX,
          minH: DEFAULT_SIZE.myDash.minSizeY,
          maxW: DEFAULT_SIZE.myDash.maxSizeX,
          maxH: DEFAULT_SIZE.myDash.maxSizeY,
        };
      }
      case "speedyEntryV2": {
        if (!block.layout) {
          block.layout = "horizontal";
        }
        return {
          x: 0,
          y: Infinity,
          w: block.w || DEFAULT_SIZE.speedyEntryV2.defaultSizeX,
          h: block.h || DEFAULT_SIZE.speedyEntryV2.defaultSizeY,
          minW: block.minW || DEFAULT_SIZE.speedyEntryV2.minSizeX,
          minH: block.minH || DEFAULT_SIZE.speedyEntryV2.minSizeY,
          maxW: block.maxW || DEFAULT_SIZE.speedyEntryV2.maxSizeX,
          maxH: block.maxH || DEFAULT_SIZE.speedyEntryV2.maxSizeY,
        };
      }
      case "speedyEntry":
      case "customApp": {
        return {
          x: 0,
          y: Infinity,
          w: DEFAULT_SIZE.dockApp.defaultSizeX,
          h: DEFAULT_SIZE.dockApp.defaultSizeY,
          minW: DEFAULT_SIZE[block.id].minSizeX,
          minH: DEFAULT_SIZE[block.id].minSizeY,
        };
      }
      case "dockApp": {
        return {
          x: 0,
          y: Infinity,
          w: DEFAULT_SIZE.dockApp.defaultSizeX,
          h: DEFAULT_SIZE.dockApp.defaultSizeY,
          minW: DEFAULT_SIZE.dockApp.minSizeX,
          minH: DEFAULT_SIZE.dockApp.minSizeY,
          maxW: DEFAULT_SIZE.dockApp.maxSizeX,
          maxH: DEFAULT_SIZE.dockApp.maxSizeY,
        };
      }
      case "myApp": {
        if (!block.layout) {
          block.layout = "horizontal";
        }
        return {
          x: 0,
          y: Infinity,
          w: DEFAULT_SIZE.myApp.defaultSizeX,
          h: DEFAULT_SIZE.myApp.defaultSizeY,
          minW: DEFAULT_SIZE.myApp.minSizeX,
          minH: DEFAULT_SIZE.myApp.minSizeY,
          maxW: DEFAULT_SIZE.myApp.maxSizeX,
          maxH: DEFAULT_SIZE.myApp.maxSizeY,
        };
      }
      case "customDash": {
        return {
          x: 0,
          y: Infinity,
          w: DEFAULT_SIZE.customDash.defaultSizeX,
          h: DEFAULT_SIZE.customDash.defaultSizeY,
          minW: DEFAULT_SIZE[block.id].minSizeX,
          minH: DEFAULT_SIZE[block.id].minSizeY,
          maxW: DEFAULT_SIZE[block.id].maxSizeX,
          maxH: DEFAULT_SIZE[block.id].maxSizeY,
        };
      }
      case "filterBtn": {
        return {
          x: 0,
          y: Infinity,
          w: 15,
          h: 6,
          minW: DEFAULT_SIZE[block.id].minSizeX,
          minH: DEFAULT_SIZE[block.id].minSizeY,
        };
      }
      case "carouselMap": {
        return {
          x: 0,
          y: Infinity,
          w: 60,
          h: 6,
          minW: DEFAULT_SIZE[block.id].minSizeX,
          minH: DEFAULT_SIZE[block.id].minSizeY,
        };
      }
      case "recentUse": {
        return {
          x: 0,
          y: Infinity,
          w: block.w || DEFAULT_SIZE.recentUse.defaultSizeX,
          h: DEFAULT_SIZE.recentUse.defaultSizeY,
          minW: block.minW || DEFAULT_SIZE.recentUse.minSizeX,
          minH: DEFAULT_SIZE.recentUse.minSizeY,
          maxW: block.maxW || DEFAULT_SIZE.recentUse.maxSizeX,
          maxH: DEFAULT_SIZE.recentUse.maxSizeY,
        };
      }
      case "noticeBoard": {
        return {
          x: 0,
          y: Infinity,
          w: block.w || DEFAULT_SIZE.noticeBoard.defaultSizeX,
          h: block.h || DEFAULT_SIZE.noticeBoard.defaultSizeY,
          minW: block.minW || DEFAULT_SIZE.noticeBoard.minSizeX,
          minH: block.minH || DEFAULT_SIZE.noticeBoard.minSizeY,
          maxW: block.maxW || DEFAULT_SIZE.noticeBoard.maxSizeX,
          maxH: block.maxH || DEFAULT_SIZE.noticeBoard.maxSizeY,
        };
      }
      case "richText": {
        return {
          x: 0,
          y: Infinity,
          w: DEFAULT_SIZE.richText.defaultSizeX,
          h: DEFAULT_SIZE.richText.defaultSizeY,
          minW: DEFAULT_SIZE.richText.minSizeX,
          minH: DEFAULT_SIZE.richText.minSizeY,
          maxW: DEFAULT_SIZE.richText.maxSizeX,
          maxH: DEFAULT_SIZE.richText.maxSizeY,
        };
      }

      default: {
        if (!block.layout) {
          block.layout = "horizontal";
        }
        return {
          x: 0,
          y: Infinity,
          w: block.w || DEFAULT_SIZE.speedyEntryV2.defaultSizeX,
          h: block.h || DEFAULT_SIZE.speedyEntryV2.defaultSizeY,
          minW: block.minW || DEFAULT_SIZE.speedyEntryV2.minSizeX,
          minH: block.minH || DEFAULT_SIZE.speedyEntryV2.minSizeY,
          maxW: block.maxW || DEFAULT_SIZE.speedyEntryV2.maxSizeX,
          maxH: block.maxH || DEFAULT_SIZE.speedyEntryV2.maxSizeY,
        };
      }
    }
  };

  getMobileComponentsSize = (block) => {
    switch (block.id) {
      case "flowManagement": {
        if (!block.layout) {
          block.layout = "horizontal";
        }
        return {
          x: 0,
          y: Infinity,
          w: DEFAULT_MOBILE_SIZE.flowManagement.horizontal.defaultSizeX,
          h: DEFAULT_MOBILE_SIZE.flowManagement.horizontal.defaultSizeY,
          minW: DEFAULT_MOBILE_SIZE.flowManagement[block.layout].minSizeX,
          minH: DEFAULT_MOBILE_SIZE.flowManagement[block.layout].minSizeY,
          maxW: DEFAULT_MOBILE_SIZE.flowManagement[block.layout].maxSizeX,
          maxH: DEFAULT_MOBILE_SIZE.flowManagement[block.layout].maxSizeY,
        };
      }
      case "flowManagementV2": {
        if (!block.layout) {
          block.layout = "horizontal";
        }
        return {
          x: 0,
          y: Infinity,
          w: DEFAULT_MOBILE_SIZE.flowManagementV2.horizontal.defaultSizeX,
          h: DEFAULT_MOBILE_SIZE.flowManagementV2.horizontal.defaultSizeY,
          minW: DEFAULT_MOBILE_SIZE.flowManagementV2[block.layout].minSizeX,
          minH: DEFAULT_MOBILE_SIZE.flowManagementV2[block.layout].minSizeY,
          maxW: DEFAULT_MOBILE_SIZE.flowManagementV2[block.layout].maxSizeX,
          maxH: DEFAULT_MOBILE_SIZE.flowManagementV2[block.layout].maxSizeY,
        };
      }
      case "leftComponents":
      case "rightComponents":
      case "oddComponents":
      case "tabComponents": {
        return {
          x: 0,
          y: Infinity,
          w: DEFAULT_MOBILE_SIZE.flowManagement.horizontal.defaultSizeX,
          h: DEFAULT_MOBILE_SIZE.flowManagement.horizontal.defaultSizeY,
          minW: DEFAULT_MOBILE_SIZE.flowManagement.horizontal.minSizeX,
          minH: DEFAULT_MOBILE_SIZE.flowManagement.horizontal.minSizeY,
          maxH: DEFAULT_MOBILE_SIZE.flowManagement.horizontal.maxSizeY,
        };
      }
      case "myDash":
      case "speedyEntryV2":
      case "speedyEntry":
      case "favorites":
      case "recentUse":
      case "noticeBoard":
      case "richText":
      case "customApp":
      case "dockApp": {
        return {
          x: 0,
          y: Infinity,
          w: DEFAULT_MOBILE_SIZE.dockApp.defaultSizeX,
          h: DEFAULT_MOBILE_SIZE.dockApp.defaultSizeY,
          minW: DEFAULT_MOBILE_SIZE[block.id].minSizeX,
          minH: DEFAULT_MOBILE_SIZE[block.id].minSizeY,
        };
      }
      case "customDash": {
        return {
          x: 0,
          y: Infinity,
          w: DEFAULT_MOBILE_SIZE.customDash.defaultSizeX,
          h: DEFAULT_MOBILE_SIZE.customDash.defaultSizeY,
          minW: DEFAULT_MOBILE_SIZE[block.id].minSizeX,
          minH: DEFAULT_MOBILE_SIZE[block.id].minSizeY,
          maxW: DEFAULT_MOBILE_SIZE[block.id].maxSizeX,
          maxH: DEFAULT_MOBILE_SIZE[block.id].maxSizeY,
        };
      }
      case "filterBtn": {
        return {
          x: 0,
          y: Infinity,
          w: 15,
          h: 6,
          minW: DEFAULT_MOBILE_SIZE[block.id].minSizeX,
          minH: DEFAULT_MOBILE_SIZE[block.id].minSizeY,
        };
      }
      case "carouselMap": {
        return {
          x: 0,
          y: Infinity,
          w: DEFAULT_MOBILE_SIZE.customDash.defaultSizeX,
          h: DEFAULT_MOBILE_SIZE.customDash.defaultSizeY,
          minW: DEFAULT_MOBILE_SIZE[block.id].minSizeX,
          minH: DEFAULT_MOBILE_SIZE[block.id].minSizeY,
        };
      }
      default: {
        return {
          // x: 0,
          // y: Infinity,
          // w: 0,
          // h: 0,
          // minW: 0,
          // minH: 0,
          // maxW: Infinity,
          // maxH: Infinity
          x: 0,
          y: Infinity,
          w: DEFAULT_MOBILE_SIZE.speedyEntryV2.defaultSizeX,
          h: DEFAULT_MOBILE_SIZE.speedyEntryV2.defaultSizeY,
          minW: block.minW || DEFAULT_MOBILE_SIZE.speedyEntryV2.minSizeX,
          minH: block.minH || DEFAULT_MOBILE_SIZE.speedyEntryV2.minSizeY,
          maxW: block.maxW || DEFAULT_MOBILE_SIZE.speedyEntryV2.maxSizeX,
          maxH: block.maxH || DEFAULT_MOBILE_SIZE.speedyEntryV2.maxSizeY,
        };
      }
    }
  };

  openMessage = () => {
    const _this = this;
    new window.FX.Slider({
      title: React.language("message.center"),
      contentWidget: {
        type: "messagecenter",
      },
      onClose: function () {
        _this._getMsgUnread(function (e) {
          if (e.count > 0) {
            _this.setState({ haveNews: true });
          } else {
            _this.setState({ haveNews: false });
          }
        });
      },
    }).show();
  };

  _getMsgUnread = (cb) => {
    let b = this;
    window.FX.Utils.ajax(
      {
        url: "/message/unread",
      },
      function (d) {
        b.setState(
          {
            haveNews: d.count > 0,
            noticeinfo: d.noticeinfo,
          },
          () => {
            b.noticeinfo = d.noticeinfo;
            b.createUpDateTip(d);
            cb && cb(d);
          }
        );
      }
    );
  };

  openCustomDesign = () => {
    this.setState({
      hasCustom: true,
    });
  };

  createUpDateTip = (c) => {
    let noticeinfo = c ? c.noticeinfo : this.state.noticeinfo;
    if (
      BsyUtils.isObjectEmpty(noticeinfo) ||
      window.$(".bsy-update-tip").length > 0
    ) {
      return;
    }
    let updateTip = window
      .$("<div class='bsy-update-tip' />")
      .css({ "z-index": window.FX.STATIC.zIndex++ })
      .appendTo(window.$("body"));
    let strKey = "bbynotice_" + noticeinfo.cookie_str;
    window
      .$("<div class='update-title' />")
      .append(window.$("<span />").text(noticeinfo.title))
      .append(
        window.$("<i class='icon icon-bsy-close' />").on("click", function () {
          const closeTime = Math.ceil(new Date().getTime() / 1000);
          const endTime = noticeinfo.endtime - closeTime;
          updateTip.animate({ right: -updateTip.width() + "px" }, 0);
          setTimeout(function () {
            updateTip.remove();
          }, 500);
          endTime > 0 &&
            window.FX.Cookie.set(strKey, closeTime, {
              expires: new Date(noticeinfo.endtime * 1000),
              path: "/",
            });
        })
      )
      .appendTo(updateTip);
    window
      .$("<div class='update-cont' />")
      .append(window.$("<span />").text(noticeinfo.content))
      .appendTo(updateTip);
    window
      .$("<div class='update-btn' />")
      .append(
        window
          .$("<a />")
          .on("click", function () {
            const closeTime = Math.ceil(new Date().getTime() / 1000);
            const endTime = noticeinfo.endtime - closeTime;
            window.FX.Utils.redirectTo(noticeinfo.link, "_blank");
            endTime > 0 &&
              window.FX.Cookie.set(strKey, closeTime, {
                expires: new Date(noticeinfo.endtime * 1000),
                path: "/",
              });
          })
          .text(React.language("view.detail"))
      )
      .appendTo(updateTip);
  };

  userMananger = () => {
    window.location.href =
      "/corp/addressbook?referer_uri=" + window.location.href;
  };

  ItemCallback = (layout, oldItem, newItem, placeholder, e, element) => {
    console.log(layout, oldItem, newItem, placeholder, e, element);
  };

  goBack = () => {
    window.location.href = window.rootDirectroy + "/";
  };

  openManageDesign = () => {
    const { components } = this.state;
    if (this.deepArrayEquals(components, this.oldComponents)) {
      BsySlidePane({
        title: React.language("manage.dashboard.design"),
        getContext: this.getContext,
        onContentCreate: () => {
          return (
            <BsyDashboardDesignAuth
              updataList={this.updataList}
              eventCustMent={this.eventCustMent}
              selectDesignType={this.state.selectDesignType}
              selectDesignId={this.state.selectDesignId}
            ></BsyDashboardDesignAuth>
          );
        },
      });
    } else {
      BsyAlert({
        title: React.language("design.custom.create.alert.title"),
        text4Ok: React.language("save"),
        OkType: "blue",
        text4Cancel: React.language("cancel"),
        type: "warning",
        ok: () => {
          this.onSave(null, () => {
            BsySlidePane({
              title: React.language("manage.dashboard.design"),
              getContext: this.getContext,
              onContentCreate: () => {
                return (
                  <BsyDashboardDesignAuth
                    updataList={this.updataList}
                    eventCustMent={this.eventCustMent}
                    selectDesignType={this.state.selectDesignType}
                    selectDesignId={this.state.selectDesignId}
                  ></BsyDashboardDesignAuth>
                );
              },
            });
          });
        },
      });
    }
  };

  getContext = (context) => {
    this.BsySlideContext = context;
  };

  getCreateContext = (context) => {
    this.BsyCreateContext = context;
  };

  deepArrayEquals = (arr1, arr2) => {
    if (arr1 === arr2) {
      return true;
    }

    if (arr1.length !== arr2.length) {
      return false;
    }

    if (Array.isArray(arr1) && Array.isArray(arr2)) {
      for (let i = 0; i < arr1.length; i++) {
        if (!this.deepArrayEquals(arr1[i], arr2[i])) {
          return false;
        }
      }
      return true;
    } else if (typeof arr1 === "object" && typeof arr2 === "object") {
      const keys1 = Object.keys(arr1);
      const keys2 = Object.keys(arr2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (const key of keys1) {
        if (!this.deepArrayEquals(arr1[key], arr2[key])) {
          return false;
        }
      }

      return true;
    }

    return arr1 === arr2;
  };

  openCreateDesign = () => {
    const { components } = this.state;
    if (this.deepArrayEquals(components, this.oldComponents)) {
      BsyDialog({
        title: React.language("create.dashboard.design"),
        height: 372,
        width: 440,
        maxLength: 26,
        noFooter: false,
        okText: React.language("ok"),
        cancelText: React.language("cancel"),
        onContentCreate: () => {
          return <CreateDesign getContext={this.getCreateContext} />;
        },
        onOk: (f) => {
          const { name, auth } = this.BsyCreateContext.state;
          if (name === "") {
            tipAlert({
              type: "warning",
              msg: React.language("dashboard.design.error.tip"),
            });
            return !1;
          }
          React.axios("/dashboard/config_dash/create", {
            name: name,
            auth: auth,
          }).then((res) => {
            if (res.data.errcode === 1) {
              tipAlert({
                type: "warning",
                msg: res.data.errmessage,
              });
              return !1;
            }
            this.setState({ dashlist: res.data.list }, () => {
              this.eventCustMent({
                id: res.data.id,
                name: name,
              });
              f.closeAlter();
            });
          });
          return !1;
        },
      });
    } else {
      BsyAlert({
        title: React.language("design.custom.create.alert.title"),
        text4Ok: React.language("save"),
        OkType: "blue",
        type: "warning",
        text4Cancel: React.language("cancel"),
        ok: () => {
          this.onSave(null, () => {
            BsyDialog({
              title: React.language("create.dashboard.design"),
              height: 372,
              width: 440,
              noFooter: false,
              okText: React.language("ok"),
              cancelText: React.language("cancel"),
              onContentCreate: () => {
                return <CreateDesign getContext={this.getCreateContext} />;
              },
              onOk: () => {
                const { name, auth } = this.BsyCreateContext.state;
                if (name === "") {
                  tipAlert({
                    type: "warning",
                    msg: React.language("dashboard.design.error.tip"),
                  });
                  return !1;
                }
                React.axios("/dashboard/config_dash/create", {
                  name: name,
                  auth: auth,
                }).then((res) => {
                  if (res.data.errcode === 1) {
                    tipAlert({
                      type: "warning",
                      msg: res.data.errmessage,
                    });
                    return !1;
                  }
                  this.setState({ dashlist: res.data.list }, () => {
                    this.eventCustMent({
                      id: res.data.id,
                      name: name,
                    });
                  });
                });
              },
            });
          });
        },
      });
    }
  };

  eventCustMent = (node) => {
    let layerRef = null;
    BsyMaskLayer({
      customCls: "hasBackground",
      onContentCreate: (ref) => {
        layerRef = ref;
        return (
          <div>
            <BsySLoading />
          </div>
        );
      },
    });
    React.axios("/corp/custom_config", {
      id: node.id,
      edit: true,
    })
      .then((res) => {
        let hasCustom = res.data.hasCustom;
        if (!res.data.hasOwnProperty("hasCustom")) {
          hasCustom = true;
        }

        const newPc = filterDuplicateWidgets(res.data.layout.pc);

        let dash = [];
        if (!Array.isArray(res.data.customDash.dash)) {
          BsyUtils.forEach(res.data.customDash.dash, (index, data) => {
            dash.push(data);
          });
          res.data.customDash.dash = dash;
        }

        const { components, customDash } = BsyUtils.getSurplusDash(
          newPc,
          res.data.customDash.dash,
          res.data.customDash.dashExist
        );
        const n = this.deepCopy(components);
        normalizeComponents(n, res.data);
        let fm = {};
        const nm = [];
        const mobile = [];
        BsyUtils.forEach(this.deepCopy(newPc), (key, val) => {
          mobile.push({
            id: val.id,
            widget: val.widget,
            widgetId: val.widgetId,
            enable: val.hasOwnProperty("enable") ? val.enable : true,
          });
          if (val.id === "flowManagementV2") {
            fm = val;
          } else {
            nm.push(val);
          }
        });
        if (fm.id === "flowManagementV2") {
          nm.unshift(fm);
        }
        let mobileHideComponents = [];
        if (res.data.layout.mobile) {
          res.data.layout.mobile.map((res) => {
            if (!res.enable) {
              mobileHideComponents.push(res.widget);
            }
            return null;
          });
        }
        const { mobileComponents } = BsyUtils.getSurplusMobileDash(
          nm,
          res.data.customDash.dash,
          res.data.customDash.dashExist
        );
        const m = this.deepCopy(mobileComponents);
        const mobileComponentsMaps = {};
        m.map((res) => {
          mobileComponentsMaps[res.widget] = res;
          return null;
        });

        // mobileSortedObjMaps 根据位置重新排序-----start
        let mobileSortedObjMaps = [];
        if (res.data.isIphoneSort) {
          mobileSortedObjMaps =
            res.data.layout.mobileLayout || mobileSortedObjMaps;
        } else {
          let mobileList = this.deepCopy(res.data.layout.mobile);
          mobileList.forEach((item, key) => {
            if (mobileComponentsMaps.hasOwnProperty(item.widget)) {
              mobileSortedObjMaps.push(mobileComponentsMaps[[item.widget]]);
            }
          });
        }
        // mobileSortedObjMaps 根据位置重新排序-----end

        n.forEach((item) => {
          if (item.id === "flowManagementV2") {
            if (res.data.flowManagementType === "combo") {
              item.minW = 12;
              item.w = 12;
              item.h = 8;
              item.maxH = 8;
              item.minH = 8;
            }
            if (res.data.flowManagementType === "card-vertical") {
              item.minW = 40;
              item.w = 40;
              item.h = 8;
              item.maxH = 8;
              item.minH = 8;
            }
            if (res.data.flowManagementType === "card-cross" || !res.data.flowManagementType) {
              item.minW = 52;
              item.w = 60;
              item.h = 6;
              item.maxH = 6;
              item.minH = 6;
            }
          }
          //将老数据gridconmengt最小高度，宽度值初始化为前端初始化值------start
          if (item.id === "speedyEntryV2") {
            item.minW = DEFAULT_SIZE.speedyEntryV2.minSizeX
          }
          if (item.id === "dockApp") {
            item.minH = DEFAULT_SIZE.dockApp.minSizeY
            item.maxH = DEFAULT_SIZE.dockApp.maxSizeY
            item.h = DEFAULT_SIZE.dockApp.defaultSizeY
            item.minW = DEFAULT_SIZE.dockApp.minSizeX
          }
          if (item.id === "myApp") {
            item.minH = DEFAULT_SIZE.myApp.minSizeY
            item.maxH = DEFAULT_SIZE.myApp.maxSizeY
            item.h = DEFAULT_SIZE.myApp.defaultSizeY
          }
          if (item.id === "flowManagement") {
            item.id = "flowManagementV2"
            item.minH = 8
            item.h = 8
            item.maxH = 8
            item.minW = 40
            item.w = 40
          }
          //将老数据gridconmengt最小高度，宽度值初始化为前端初始化值------end
        });

        if (res.data.dashlist) {
          let dashDesignMap = {};
          let fId = "";
          res.data.dashlist.map((res1, key) => {
            dashDesignMap[res1.id] = res1;
            if (key === 0) {
              fId = res1.id;
            }
          });
          this.setState(
            {
              components: n,
              mobileHideComponents: mobileHideComponents,
              iphoneSortTianyong: this.deepCopy(
                res.data.layout.mobile ? res.data.layout.mobile : mobile
              ),
              mobile: res.data.layout.mobile ? res.data.layout.mobile : mobile,
              mobileComponents: m,
              mobileComponentsMaps: { ...mobileComponentsMaps },
              mobileSortedObjMaps: mobileSortedObjMaps,
              mobileCustomDash: {
                dash: customDash,
                enable: true,
              },
              customDash: {
                dash: customDash,
                enable: true,
              },
              selectDesignId: res.data.id,
              dashlist: res.data.dashlist,
              dashDesignMap: dashDesignMap,
              isIphoneSort: res.data.isIphoneSort,
              loadSuccess: true,
              hasCustom: hasCustom,
              richText: { ...res.data.richText },
              speedyEntry: { ...res.data.speedyEntry },
              noticeBoard: { ...res.data.noticeBoard },
              carouselMap: { ...res.data.carouselMap },
              customApp: { ...res.data.customApp },
              preferences: { ...res.data.preferences },
              flowManagementType: res.data.flowManagementType,

              dockApp: { ...res.data.dockApp },
              myDash: res.data.myDash ? res.data.myDash : customDash,
              favorites: res.data.favorites ? res.data.favorites : [],
            },
            () => {
              this.checkListStatus();
              this.BsySlideContext &&
                this.BsySlideContext.onRemoveRoot &&
                this.BsySlideContext.onRemoveRoot();
              this.nameWidthEl.current &&
                this.setState({
                  nameWidth: this.nameWidthEl.current.offsetWidth + 5,
                });
            }
          );
        } else {
          this.setState(
            {
              components: n,
              mobileHideComponents: mobileHideComponents,
              mobile: res.data.layout.mobile ? res.data.layout.mobile : mobile,
              mobileComponents: m,
              mobileComponentsMaps: { ...mobileComponentsMaps },
              mobileSortedObjMaps: mobileSortedObjMaps,
              customDash: {
                dash: customDash,
                enable: true,
              },
              loadSuccess: true,
              hasCustom: hasCustom,
              speedyEntry: { ...res.data.speedyEntry },
              customApp: { ...res.data.customApp },
              isIphoneSort: res.data.isIphoneSort,
              noticeBoard: { ...res.data.noticeBoard },
              carouselMap: { ...res.data.carouselMap },
              flowManagementType: res.data.flowManagementType,
              iphoneSortTianyong: this.deepCopy(
                res.data.layout.mobile ? res.data.layout.mobile : mobile
              ),
              preferences: { ...res.data.preferences },
              dockApp: { ...res.data.dockApp },
              myDash: res.data.myDash ? res.data.myDash : customDash,
              favorites: res.data.favorites ? res.data.favorites : [],
            },
            () => {
              this.checkListStatus();
              this.BsySlideContext &&
                this.BsySlideContext.onRemoveRoot &&
                this.BsySlideContext.onRemoveRoot();
            }
          );
        }
        this.applist(() => {
          layerRef && layerRef.close();
        });
      })
      .catch((res) => {
        console.error(res);
        layerRef && layerRef.close();
      });
  };

  updataList = (l, i) => {
    let dashDesignMap = {};
    l.map((res1) => {
      dashDesignMap[res1.id] = res1;
    });
    if (i) {
      this.setState(
        { dashDesignMap: dashDesignMap, dashlist: l, selectDesignId: i },
        () => {
          this.changeDockCorpName(dashDesignMap[i].name);
        }
      );
    } else {
      this.setState({ dashDesignMap: dashDesignMap, dashlist: l });
    }
  };

  onSortEnd = (data) => {
    const { oldIndex, newIndex } = data;
    const { mobileComponents } = this.state;
    const scr = arrayMoveImmutable(mobileComponents, oldIndex, newIndex);
    this.setState(
      {
        mobileComponents: scr,
      },
      () => { }
    );
  };

  onSwitchDesign = (e) => {
    const { dashlist, selectDesignId, components } = this.state;
    this.hideTooltip();
    let menu = [];
    dashlist.map((res) => {
      let item = {
        text: res.name,
        colorType: "",
        afterText: !res.editEnable ? React.language("default") : "",
        afterTextColor: "#4D609F",
        selected: selectDesignId === res.id,
        extIcon: selectDesignId === res.id ? "icon-ok" : "",
        extIconColor: "#0265ff",
        click: () => {
          if (this.deepArrayEquals(components, this.oldComponents)) {
            this.eventCustMent(res);
          } else {
            BsyAlert({
              title: React.language("design.custom.create.alert.title"),
              text4Ok: React.language("save"),
              OkType: "blue",
              type: "warning",
              text4Cancel: React.language("cancel"),
              ok: () => {
                this.onSave(null, () => {
                  this.eventCustMent(res);
                });
              },
            });
          }
        },
      };
      menu.push(item);
    });
    BsyAlertMenu({
      item: menu,
      // renderEl: e.currentTarget,
      width: 240,
      target: e.currentTarget,
    });
  };

  getPreviewContext = (f) => {
    this.previewContext = f;
  };

  onOpenPreview = () => {
    const {
      selectDesignId,
      selectDesignType,
      apps,
      components,
      dockCorp,
      dockItem,
      customApp,
      carouselMap,
      recentUse,
      richText,
      preferences,
      noticeBoard,
      dockApp,
      customDash,
      speedyEntry,
      flowManagementType,
      mobileComponents,
      mobile,
    } = this.state;
    let bakcomponents = components.sort((s, j) => {
      return s.y - j.y;
    });

    if (navigator.userAgent.indexOf("Firefox") > -1) {
      bakcomponents = bakcomponents.reverse();
    }

    let bakMobileComponents = mobileComponents.sort((s, j) => {
      return s.y - j.y;
    });

    if (navigator.userAgent.indexOf("Firefox") > -1) {
      bakMobileComponents = bakMobileComponents.reverse();
    }

    const nMobile = [];
    const nM = {};
    mobile.map((res) => {
      nM[res.widget] = res;
      return null;
    });

    bakMobileComponents.map((res) => {
      nMobile.push({
        widget: res.widget,
        id: res.id,
        enable: nM[res.widget] ? nM[res.widget].enable : true,
      });
      return null;
    });
    let flowManagement = {};
    let customAppList = { apps: [] };
    let dockAppList = { corp: "" };
    !BsyUtils.isObjectEmpty(this.state.customApp) &&
      this.state.customApp.apps.map((res) => {
        customAppList.apps.push(res._id);
        return null;
      });
    this.state.dockApp && (dockAppList.corp = this.state.dockApp.corp);
    let seq = 0;
    let dashSeq = 0;
    nMobile.map((res) => {
      if (
        res.id === "flowManagement" ||
        res.id === "flowManagementV2" ||
        res.id === "speedyEntry" ||
        res.id === "speedyEntryV2" ||
        res.id === "customApp" ||
        res.id === "dockApp" ||
        res.id === "carouselMap" ||
        res.id === "recentUse" ||
        res.id === "noticeBoard" ||
        res.id === "richText" ||
        res.id === "myDash"
      ) {
        seq++;
      }

      if (res.id === "flowManagement" || res.id === "flowManagementV2") {
        flowManagement.enable = res.enable;
      }

      if (res.id === "speedyEntry" || res.id === "speedyEntryV2") {
        speedyEntry.seq = seq;
        speedyEntry.enable = res.enable;
      }

      if (res.id === "customApp") {
        customAppList.seq = seq;
        customAppList.enable = res.enable;
      }

      if (res.id === "dockApp") {
        dockAppList.seq = seq;
        dockAppList.enable = res.enable;
      }
      if (res.id === "carouselMap") {
        carouselMap.seq = seq;
        carouselMap.enable = res.enable;
      }
      if (res.id === "recentUse") {
        recentUse.seq = seq;
        recentUse.enable = res.enable;
      }
      if (res.id === "richText") {
        richText.seq = seq;
        richText.enable = res.enable;
      }

      if (res.id === "noticeBoard") {
        noticeBoard.seq = seq;
        noticeBoard.enable = res.enable;
      }

      if (res.id === "customDash") {
        dashSeq++;
      }
      return null;
    });
    customDash.enable = dashSeq !== 0;
    customDash.seq = 10;
    localStorage.setItem(
      "preview.custom.dashboard",
      JSON.stringify({
        mode: selectDesignType !== "company" ? "custom" : "default",
        layout: {
          enable: true,
          pc: bakcomponents,
          mobile: nMobile,
        },
        id: selectDesignId,
        flowManagement: flowManagement,
        customApp: customAppList,
        dockApp: dockAppList,
        customDash: customDash,
        speedyEntry: speedyEntry,
        carouselMap: carouselMap,
        recentUse: recentUse,
        richText: richText,
        noticeBoard: noticeBoard,
        preferences: preferences,
      })
    );
    BsySlidePane({
      // title: React.language("manage.dashboard.design"),
      onHeaderMenu: () => {
        return (
          <div className="previewChangeModeMenu">
            <div className="switch-btn">
              <i
                className="icon-btn selected icon-computer"
                onClick={(e) => {
                  e.target.nextSibling.classList.remove("selected");
                  e.target.classList.add("selected");
                  this.previewContext &&
                    this.previewContext.changePreviewMode &&
                    this.previewContext.changePreviewMode("computer");
                }}
              ></i>
              <i
                className="icon-btn icon-widget-phone"
                onClick={(e) => {
                  e.target.previousSibling.classList.remove("selected");
                  e.target.classList.add("selected");
                  this.previewContext &&
                    this.previewContext.changePreviewMode &&
                    this.previewContext.changePreviewMode("phone");
                }}
              ></i>
            </div>
          </div>
        );
      },
      onContentCreate: () => {
        return (
          <BsyDashboardDesignPreviewPane
            components={components}
            mode={"preview"}
            customApp={customApp}
            flowManagementType={flowManagementType}
            carouselMap={carouselMap}
            recentUse={recentUse}
            richText={richText}
            noticeBoard={noticeBoard}
            dockApp={dockApp}
            customDash={customDash}
            speedyEntry={speedyEntry}
            preferences={preferences}
            dockCorp={dockCorp}
            dockItem={dockItem}
            apps={apps}
            getPreviewContext={this.getPreviewContext}
          ></BsyDashboardDesignPreviewPane>
        );
      },
    });
  };

  oldName = "";

  changeDockCorpName = (e) => {
    const { dashDesignMap, selectDesignId } = this.state;
    let name = e;
    dashDesignMap[selectDesignId].name = name;
    this.nameWidthEl.current.textContent = name;
    // e.target.style.width = this.nameWidthEl.current.offsetWidth + 5;
    this.setState({
      dashDesignMap,
      nameWidth: this.nameWidthEl.current.offsetWidth + 5,
    });
  };

  setOldName = () => {
    const { dashDesignMap, selectDesignId } = this.state;
    this.oldName = dashDesignMap[selectDesignId].name;
  };

  blurDockCorpName = (e) => {
    const { dashDesignMap, selectDesignId } = this.state;
    if (e.target.value === "") {
      dashDesignMap[selectDesignId].name = this.oldName;
      this.nameWidthEl.current.text = this.oldName;
      this.setState({
        dashDesignMap,
        nameWidth: this.nameWidthEl.current.offsetWidth + 5,
      });
      return;
    }
    React.axios("/dashboard/config_dash/rename", {
      id: selectDesignId,
      name: e.target.value,
    }).then(() => {
      dashDesignMap[selectDesignId].name = e.target.value;
      this.setState({ dashDesignMap });
    });
  };
  onEmitEidtstate = (value, data) => {
    this.setState({
      newIsDraggable: true,
      richText: data,
    });
  };
  onActionEmitEidtstate = () => {
    this.setState({
      newIsDraggable: false,
    });
  };
  getAuthContext = (context) => {
    this.BsyAuthContext = context;
  };

  openDesignAuth = () => {
    const { dashDesignMap, selectDesignId } = this.state;
    BsyDialog({
      title: React.language("set.dashboard.design.auth"),
      height: 380,
      width: 440,
      noFooter: false,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: () => {
        return (
          <CreateDesign
            getContext={this.getAuthContext}
            auth={dashDesignMap[selectDesignId].auth}
            showNameBox={false}
          />
        );
      },
      onOk: () => {
        const { auth } = this.BsyAuthContext.state;
        React.axios("/dashboard/config_dash/auth", {
          id: selectDesignId,
          auth: auth,
        }).then((res) => {
          let designMap = {};
          res.data.list.map((res1) => {
            designMap[res1.id] = res1;
          });
          this.setState({ designList: res.data.list, designMap });
        });
      },
    });
  };

  render() {
    const {
      mobile,
      myDash,
      apps,
      nameWidth,
      mobileComponentsMaps,
      flowManagementType,
      preferences,
      newIsDraggable,
      mobileHideComponents,
      mobileComponents,
      designMode,
      selectDesignId,
      dashDesignMap,
      selectDesignType,
      list,
      components,
      customDash,
      speedyEntry,
      customApp,
      carouselMap,
      recentUse,
      richText,
      noticeBoard,
      hasCustom,
      loadSuccess,
      dockApp,
      dockItem,
      dockCorp,
      droppingItem,
      iphoneSortTianyong,
      isOneceonLayoutChangeIphone,
      mobileSortedObjMaps,
    } = this.state;
    console.log(
      11,
      iphoneSortTianyong,
      mobile,
      mobileSortedObjMaps,
      components
    );
    setPageTitle(React.language("dash.custom"));
    return (
      <>

        <div className="design-pane-title">
          {/* <div className="go-back" onClick={this.goBack}>
                        <i className="icon-bsy-left"></i>
                    </div>
                    <div className="title-name">
                        {selectDesignType !== "custom" ? React.language('set.worker.dashboard.design') : React.language('dash.design.custom')}
                    </div> */}
          {
            <BsySystemLeftMenu
              homeIcon={() => {
                return (
                  <i className="icon-bsy-left" style={{ fontSize: 22 }}></i>
                );
              }}
              backTitle={React.language("dashboard")}
              onRenderTitle={() => (
                <div
                  className="left-title"
                // onClick={this.changeTeam}
                >
                  {selectDesignType !== "custom"
                    ? React.language("set.worker.dashboard.design")
                    : React.language("dash.design.custom")}
                </div>
              )}
            />
          }

          <div className={"right-menu"}>
            <BsySystemRightMenu />
          </div>
        </div>
        {(!hasCustom && selectDesignType === "custom") || (
          <div className="design-top-menu">
            <div className="design-left-menu">
              {selectDesignType !== "custom" && (
                <>
                  <div
                    className="create-design left-btn"
                    onClick={this.openCreateDesign}
                  >
                    <i className="icon-add"></i>
                    <span>{React.language("create")}</span>
                  </div>
                  <div
                    className="manage-design left-btn"
                    onClick={this.openManageDesign}
                  >
                    <i className="icon-data-auth"></i>
                    <span>{React.language("manage.dashboard.design")}</span>
                  </div>
                </>
              )}
            </div>
            <div className="design-center-menu">
              {selectDesignType !== "custom" && dashDesignMap && (
                <div className="center-btn">
                  <div className="nameTitle">
                    <div
                      className="name-input"
                      data-for="r-rename-tip"
                      data-tip={React.language("rename")}
                      onMouseEnter={(e) => {
                        this.showTooltip(
                          e.currentTarget,
                          React.language("rename"),
                          "bottom",
                          10
                        );
                      }}
                      onMouseLeave={() => {
                        this.hideTooltip();
                      }}
                    >
                      <input
                        type="text"
                        maxLength={26}
                        style={{ width: nameWidth }}
                        value={dashDesignMap[selectDesignId].name}
                        onFocus={this.setOldName}
                        onChange={(e) =>
                          this.changeDockCorpName(e.target.value)
                        }
                        onBlur={this.blurDockCorpName}
                      />
                    </div>
                    <span ref={this.nameWidthEl}>
                      {dashDesignMap[selectDesignId].name}
                    </span>
                  </div>
                  <i
                    className="icon-bsy-iconqiehuan1"
                    onClick={this.onSwitchDesign}
                    data-for="r-switch-tip"
                    data-tip={React.language("change.switch.design")}
                    onMouseEnter={(e) => {
                      this.showTooltip(
                        e.currentTarget,
                        React.language("change.switch.design"),
                        "bottom",
                        10
                      );
                    }}
                    onMouseLeave={() => {
                      this.hideTooltip();
                    }}
                  ></i>
                </div>
              )}
            </div>
            <div className="design-right-menu">
              <div
                className={`icon-btn right-btn ${designMode === "computer" ? "select" : ""
                  }`}
                onClick={() => {
                  let iphoneSortTianyong = JSON.parse(
                    JSON.stringify(this.state.iphoneSortTianyong)
                  );
                  this.setState({
                    designMode: "computer",
                    mobile: iphoneSortTianyong,
                    isOneceonLayoutChangeIphone: true,
                  });
                }}
              >
                <i className="icon-computer"></i>
              </div>
              <div
                className={`icon-btn right-btn ${designMode === "phone" ? "select" : ""
                  }`}
                onClick={() => {
                  let iphoneSortTianyong = JSON.parse(
                    JSON.stringify(this.state.iphoneSortTianyong)
                  );
                  let mobileSortedObjMaps = this.state.mobileSortedObjMaps;
                  mobileSortedObjMaps.forEach((item, key) => {
                    item.y = key + 3;
                  });
                  this.setState({
                    designMode: "phone",
                    mobile: iphoneSortTianyong,
                    isOneceonLayoutChangeComputer: true,
                    mobileSortedObjMaps: mobileSortedObjMaps,
                  });
                }}
              >
                <i className="icon-widget-phone"></i>
              </div>
              {hasCustom && selectDesignType === "custom" && (
                <BsyIconBtn
                  text={React.language("close.custom.design")}
                  type="white"
                  click={() => {
                    BsyAlert({
                      title: React.language("design.custom.close.alert.title"),
                      msg: React.language("design.custom.close.alert.msg"),
                      type: "warning",
                      text4Ok: React.language("ok"),
                      OkType: "red",
                      text4Cancel: React.language("cancel"),
                      ok: () => {
                        this.onSave("close");
                      },
                    });
                  }}
                  mode={window.mode}
                />
              )}
              <div
                className="preview-btn right-btn"
                onClick={this.onOpenPreview}
              >
                <span>{React.language("preview")}</span>
              </div>
              <div className="save-btn right-btn" onClick={this.onSave}>
                <span>{React.language("save")}</span>
              </div>
            </div>
          </div>
        )}
        {loadSuccess && (
          <>
            {!(!hasCustom && selectDesignType === "custom") ? (
              <div className={"bsy-workspace-pane-design"}>
                <div
                  className={"bsy-frame-left"}
                  style={{
                    pointerEvents: designMode === "phone" ? "none" : "",
                  }}
                >
                  <div className={"title"}>
                    {React.language("dashboard.page.components")}
                  </div>
                  <div className="bsy-frame-menu">
                    <div id="list">
                      {list.map((block) => (
                        <div
                          className={
                            "dashboard-widget widget " +
                            block.id +
                            "-float" +
                            (block.disable ? " disable " : "")
                          }
                          key={block.id}
                          draggable={true}
                          onDragStart={(e) => {
                            this.handleDragStart(e, block);
                          }}
                        >
                          {this.renderTltleHtml(block)}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {designMode === "computer" && (
                  <div
                    className={"bsy-frame-content"}
                  // onDrop={this.handleDrop}
                  // onDragOver={this.handleDragEnter}
                  // onDragEnter={e => e.preventDefault()}
                  >
                    <ResponsiveGridLayout
                      {...this.props}
                      breakpoints={{ lg: 1200 }}
                      cols={{ lg: 60 }}
                      rowHeight={18}
                      margin={[16, 16]}
                      onLayoutChange={this.onLayoutChange}
                      ItemCallback={this.ItemCallback}
                      droppingItem={droppingItem}
                      isBounded={false}
                      isDroppable={true}
                      static={true}
                      placeholder={{}}
                      isDraggable={newIsDraggable}
                      allowOverlap={false}
                      useCSSTransforms={true}
                      isResizable={newIsDraggable}
                      onDropDragOver={() => {
                        if (
                          !newIsDraggable ||
                          _.isEmpty(this.currentDragElData)
                        ) {
                          return;
                        }
                        let WH = this.getComponentsSize(this.currentDragElData);
                        let newWH = { w: WH.w, h: WH.h };
                        // const droppingItemX = e.nativeEvent.layerX;
                        // const droppingItemY = e.nativeEvent.layerY;
                        // console.log(`droppingItem 位置：(${droppingItemX}, ${droppingItemY})`, e);
                        return newWH;
                      }}
                      onDragStart={() => { }}
                      onDrop={(l, i, e) => {
                        this.handleDrop(l, i, e);
                      }}
                      onResizeStop={(l, i, e, f, k) => { }}
                    >
                      {components &&
                        components.map((block, index) => (
                          <div
                            className={"react-grid-" + block.id}
                            key={
                              block.id === "invalidBlock"
                                ? `${block.widget}-${index}` // 不知道是后端还是其他原因，没有权限的id会变成一样，前端需要区分，否则会重叠
                                : block.widget
                            }
                            x={block.x}
                            y={block.y}
                            w={block.w}
                            h={block.h}
                            data-grid={{
                              isResizable:
                                block.id === "customDash" ||
                                  block.id === "flowManagement" ||
                                  block.id === "speedyEntry" ||
                                  block.id === "myDash" ||
                                  block.id !== "carouselMap" ||
                                  block.id !== "speedyEntryV2" ||
                                  block.id !== "recentUse" ||
                                  block.id !== "noticeBoard"
                                  ? null
                                  : true,
                              resizeHandle:
                                block.id !== "customDash" ||
                                  block.id !== "flowManagement" ||
                                  block.id !== "speedyEntry" ||
                                  block.id !== "myDash" ||
                                  block.id !== "carouselMap" ||
                                  block.id !== "speedyEntryV2" ||
                                  block.id !== "recentUse" ||
                                  block.id !== "noticeBoard" ||
                                  block.id !== "richText"
                                  ? null
                                  : true,
                              ...this.getComponentsSize(block),
                              i: block.widget,
                              x: block.x,
                              y: block.y,
                              w: block.w,
                              h: block.h,
                            }}
                          >
                            <BsyDashboardComponent
                              block={block}
                              // key={block.widget + block.w + block.h}
                              mode={"edit"}
                              designType={selectDesignType}
                              customApp={customApp}
                              dockApp={dockApp}
                              myDash={myDash}
                              carouselMap={carouselMap}
                              recentUse={recentUse}
                              richText={richText}
                              noticeBoard={noticeBoard}
                              dockItem={dockItem}
                              designMode={designMode}
                              flowManagementType={flowManagementType}
                              dockCorp={dockCorp}
                              customDash={customDash}
                              speedyEntry={speedyEntry}
                              preferences={preferences}
                              onDelComponent={this.delComponents}
                              onFlowManagement={this.onFlowManagement}
                              onCustomApp={this.onCustomApp}
                              onDockApp={this.onDockApp}
                              onEmitFlowManagementType={
                                this.onEmitFlowManagementType
                              }
                              onEmitCarousel={this.onEmitCarousel}
                              onEmitEidtstate={this.onEmitEidtstate}
                              onActionEmitEidtstate={this.onActionEmitEidtstate}
                              onEmitSaveBoardNotice={this.onEmitSaveBoardNotice}
                              onEmitRecentUseValue={this.onEmitRecentUseValue}
                              onSpeedyEntry={this.onSpeedyEntry}
                              onMyApp={this.onMyApp}
                              apps={apps}
                            />
                          </div>
                        ))}
                    </ResponsiveGridLayout>
                  </div>
                )}
                {designMode === "phone" && (
                  <div className={"bsy-frame-content mobile"}>
                    <div className="mobile-container">
                      <div className="mobile-main">
                        <div className="mobile-body">
                          <div className="mobile-sortable-content">
                            <ResponsiveGridLayout
                              {...this.props}
                              breakpoints={{ lg: 1200 }}
                              cols={{ lg: 60 }}
                              rowHeight={18}
                              onLayoutChange={(layout, layouts) => {
                                this.onLayoutChangeIphone(layout, layouts);
                              }}
                              ItemCallback={this.ItemCallback}
                              droppingItem={droppingItem}
                              isBounded={false}
                              containerPadding={[5, 5]}
                              margin={[5, 5]}
                              static={true}
                              isDraggable={true}
                              allowOverlap={false}
                              useCSSTransforms={true}
                              isResizable={false}
                              onDropDragOver={() => {
                                // let WH = this.getMobileComponentsSize(
                                //   this.currentDragElData
                                // );
                                // let newWH = { w: WH.w, h: WH.h };
                                // // const droppingItemX = e.nativeEvent.layerX;
                                // // const droppingItemY = e.nativeEvent.layerY;
                                // // console.log(`droppingItem 位置：(${droppingItemX}, ${droppingItemY})`, e);
                                // return newWH;
                              }}
                              onDragStart={() => {
                                this.setState({
                                  isIphoneSort: true,
                                });
                              }}
                            // onDrop={(l) => {
                            //   console.log(1)
                            //   const nMobileHideComponents = [];
                            //   mobileHideComponents.map((res) => {
                            //     if (this.currentDragElData.widget !== res) {
                            //       nMobileHideComponents.push(res);
                            //     }
                            //     return !1;
                            //   });
                            //   const nMobileComponents = [];
                            //   const nMobileComponentsMaps = {};
                            //   let xyMAP = {};
                            //   l.map((res) => {
                            //     if (res.i === "__dropping-elem__") {
                            //       xyMAP[this.currentDragElData.widget] = {
                            //         x: res.x,
                            //         y: res.y,
                            //       };
                            //     } else {
                            //       xyMAP[res.i || res.widget] = {
                            //         x: res.x,
                            //         y: res.y,
                            //       };
                            //     }
                            //     return null;
                            //   });
                            //   const mobile = [];
                            //   mobileComponents.map((res) => {
                            //     if (xyMAP[res.widget]) {
                            //       res.x = xyMAP[res.widget].x;
                            //       res.y = xyMAP[res.widget].y;
                            //     }
                            //     nMobileComponents.push(res);
                            //     nMobileComponentsMaps[res.widget] = res;
                            //     return null;
                            //   });

                            //   const nnMobileComponents =
                            //     nMobileComponents.sort((s, j) => {
                            //       return s.y - j.y;
                            //     });
                            //   nnMobileComponents.map((res) => {
                            //     mobile.push({
                            //       widget: res.widget,
                            //       widgetId: res.widgetId,
                            //       id: res.id,
                            //       enable: res.hasOwnProperty("enable")
                            //         ? res.enable
                            //         : true,
                            //     });
                            //     return null;
                            //   });
                            //   this.setState({
                            //     mobile: mobile,
                            //     mobileHideComponents: [
                            //       ...nMobileHideComponents,
                            //     ],
                            //     mobileComponents: nnMobileComponents,
                            //     mobileComponentsMaps: nMobileComponentsMaps,
                            //   });
                            // }}
                            // onDragStart={(e, i, f, d) => {
                            //   console.log(e);
                            //   console.log(i);
                            //   console.log(f);
                            //   console.log(d);
                            //   // e.preventDefault();
                            //   // e.stopPropagation();
                            // }}
                            >
                              {mobile &&
                                mobile.map((res) => {
                                  // let block = res.widget
                                  //   ? mobileComponentsMaps[res.widget]
                                  //   : mobileComponentsMaps[res.widgetId];
                                  let block = mobileSortedObjMaps.filter(
                                    (item) => {
                                      return item.widget === res.widget;
                                    }
                                  )[0];
                                  // console.log()
                                  if (!block) {
                                    return <></>;
                                  }
                                  // console.log({
                                  //   static: block.id === "flowManagementV2",
                                  //   isResizable: false,
                                  //   resizeHandle: null,
                                  //   ...this.getMobileComponentsSize(block),
                                  //   i: block.widget,
                                  //   x: block.x,
                                  //   y:
                                  //     block.id === "flowManagementV2"
                                  //       ? 0
                                  //       : block.y,
                                  // });
                                  return (
                                    res.enable && (
                                      <div
                                        className={
                                          "mobile-item react-grid-" + block.id
                                        }
                                        key={block.widget}
                                        data-grid={{
                                          static:
                                            block.id === "flowManagementV2",
                                          isResizable: false,
                                          resizeHandle: null,
                                          ...this.getMobileComponentsSize(
                                            block
                                          ),
                                          i: block.widget,
                                          x: block.x,
                                          y:
                                            block.id === "flowManagementV2"
                                              ? 0
                                              : block.y,
                                        }}
                                      >
                                        <BsyDashboardComponent
                                          block={block}
                                          key={block.widget + block.w + block.h}
                                          mode={"edit"}
                                          designType={selectDesignType}
                                          customApp={customApp}
                                          carouselMap={carouselMap}
                                          recentUse={recentUse}
                                          richText={richText}
                                          noticeBoard={noticeBoard}
                                          dockApp={dockApp}
                                          myDash={myDash}
                                          flowManagementType={
                                            flowManagementType
                                          }
                                          designMode={designMode}
                                          dockItem={dockItem}
                                          dockCorp={dockCorp}
                                          customDash={customDash}
                                          speedyEntry={speedyEntry}
                                          preferences={preferences}
                                          onDelComponent={this.delComponents}
                                          onFlowManagement={
                                            this.onFlowManagement
                                          }
                                          onCustomApp={this.onCustomApp}
                                          onDockApp={this.onDockApp}
                                          onEmitCarousel={this.onEmitCarousel}
                                          onEmitSaveBoardNotice={
                                            this.onEmitSaveBoardNotice
                                          }
                                          onEmitRecentUseValue={
                                            this.onEmitRecentUseValue
                                          }
                                          onSpeedyEntry={this.onSpeedyEntry}
                                          onMyApp={this.onMyApp}
                                        />

                                        {block.id === "flowManagementV2" ? (
                                          ""
                                        ) : (
                                          <i
                                            className="icon-bsy-filter-hide"
                                            data-for="r-hide-tip"
                                            data-tip={React.language("hide")}
                                            onMouseEnter={(e) => {
                                              this.showTooltip(
                                                e.currentTarget,
                                                React.language("hide"),
                                                "bottom",
                                                10
                                              );
                                            }}
                                            onMouseLeave={() => {
                                              this.hideTooltip();
                                            }}
                                            onMouseDown={(e) => {
                                              e.stopPropagation();
                                              e.preventDefault();
                                              this.hideTooltip();
                                              BsyUtils.forEach(
                                                mobile,
                                                (key, val) => {
                                                  if (
                                                    val.widget === block.widget
                                                  ) {
                                                    val.enable = false;
                                                  }
                                                }
                                              );
                                              this.setState({
                                                mobile: mobile,
                                                mobileHideComponents: [
                                                  ...mobileHideComponents,
                                                  block.widget,
                                                ],
                                              });
                                            }}
                                          ></i>
                                        )}
                                      </div>
                                    )
                                  );
                                })}
                            </ResponsiveGridLayout>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {designMode === "phone" && (
                  <div className="hidden-mobile-list-wrapper">
                    <div className="wrapper-label">
                      {React.language("dash.mobileLayout.hide")}
                    </div>
                    {mobileHideComponents.length <= 0 && (
                      <div className="wrapper-empty-text">
                        {React.language("dash.mobileLayout.hideEmpty")}
                      </div>
                    )}
                    {mobileHideComponents.length > 0 && (
                      <div className="main-content">
                        <div className="main-list">
                          {mobile &&
                            mobile.map((res) => {


                              // console.log()
                              if (!mobileComponentsMaps?.[res.widget]) {
                                return <></>;
                              }

                              return (
                                !res.enable && (
                                  <div
                                    className="main-list-item"
                                    key={res.widget}
                                    isDraggable={true}
                                    draggable={
                                      mobileComponentsMaps[res.widget].id !==
                                      "flowManagementV2"
                                    }
                                    onDragStart={(e) => {
                                      this.handleDragStart(
                                        e,
                                        mobileComponentsMaps[res.widget]
                                      );
                                    }}
                                  >
                                    <div className="item-content">
                                      <BsyDashboardComponent
                                        block={mobileComponentsMaps[res.widget]}
                                        key={
                                          mobileComponentsMaps[res.widget]
                                            .widget +
                                          mobileComponentsMaps[res.widget].w +
                                          mobileComponentsMaps[res.widget].h
                                        }
                                        mode={"edit"}
                                        designType={selectDesignType}
                                        customApp={customApp}
                                        dockApp={dockApp}
                                        myDash={myDash}
                                        designMode={designMode}
                                        carouselMap={carouselMap}
                                        recentUse={recentUse}
                                        richText={richText}
                                        noticeBoard={noticeBoard}
                                        flowManagementType={flowManagementType}
                                        dockItem={dockItem}
                                        dockCorp={dockCorp}
                                        customDash={customDash}
                                        speedyEntry={speedyEntry}
                                        preferences={preferences}
                                        onDelComponent={this.delComponents}
                                        onFlowManagement={this.onFlowManagement}
                                        onCustomApp={this.onCustomApp}
                                        onDockApp={this.onDockApp}
                                        onEmitFlowManagementType={
                                          this.onEmitFlowManagementType
                                        }
                                        onEmitCarousel={this.onEmitCarousel}
                                        onEmitSaveBoardNotice={
                                          this.onEmitSaveBoardNotice
                                        }
                                        onEmitRecentUseValue={
                                          this.onEmitRecentUseValue
                                        }
                                        onSpeedyEntry={this.onSpeedyEntry}
                                        onMyApp={this.onMyApp}
                                      />
                                    </div>
                                    <i
                                      className="icon-bsy-reportmenu-13"
                                      data-for="r-show-tip"
                                      data-tip={React.language("show")}
                                      onMouseEnter={(e) => {
                                        this.showTooltip(
                                          e.currentTarget,
                                          React.language("show"),
                                          "bottom",
                                          10
                                        );
                                      }}
                                      onMouseLeave={() => {
                                        this.hideTooltip();
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        this.hideTooltip();
                                        BsyUtils.forEach(mobile, (key, val) => {
                                          if (
                                            val.widget ===
                                            mobileComponentsMaps[res.widget]
                                              .widget
                                          ) {
                                            val.enable = true;
                                          }
                                        });
                                        this.setState({
                                          mobile: mobile,
                                          mobileHideComponents: [
                                            ...mobileHideComponents.filter(
                                              (res1) => {
                                                return res1 !== res.widget;
                                              }
                                            ),
                                          ],
                                        });
                                      }}
                                    ></i>
                                  </div>
                                )
                              );
                            })}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div className={"bsy-workspace-pane-noCustom"}>
                <div className="design-close-custom">
                  <img src={closeCustomImg} alt="" />
                  <div className="close-msg">
                    {React.language("design.close.msg")}
                  </div>
                  <BsyIconBtn
                    text={React.language("design.custom.open")}
                    type="blue"
                    click={() => {
                      this.openCustomDesign();
                    }}
                    mode={window.mode}
                  />
                </div>
              </div>
            )}
          </>
        )}
      </>
    );
  }
}

export default withRouter(BsyDashboardDesign);
